//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export enum AcceptInvitationErrors {
  InviteExpired = "InviteExpired",
  InviteInvalid = "InviteInvalid",
  InviteAlreadyAccepted = "InviteAlreadyAccepted",
}

export interface AcceptSchooldocentInviteCommand {
  schooldocentInviteId: string;
  token: string;
}

export interface AcceptSchooldocentInviteResponse {
  schoolSlug: string;
}

export interface ActiveLesModel {
  schoolSlug: string;
  lesId: string;
  klasName: string;
}

export interface AddLeerlingNotitieCommand {
  leerlingId: string;
  notitie: string;
}

export enum AddMessageErrors {
  TooManyAttachments = "TooManyAttachments",
}

export interface AddSchoolCommand {
  brin: string;
}

export enum AddSchoolErrors {
  SchoolAlreadyExists = "SchoolAlreadyExists",
}

export interface AddSchoolResponse {
  schoolSlug: string;
}

export interface AddSportCommand {
  name: string;
}

export interface AddTicketMessageRequest {
  content: string;
  fileIds: string[];
}

export interface AddVerenigingCommand {
  name: string;
  sportId: string;
}

export interface AddVerenigingResponse {
  id: string;
  alreadyExists: boolean;
}

export enum AdminStatHistorySoort {
  ScholenMetLeerlingen = "ScholenMetLeerlingen",
  TotaalLeerlingen = "TotaalLeerlingen",
  LessenGegeven = "LessenGegeven",
  ScoresIngevoerd = "ScoresIngevoerd",
  WachtendOpActivatie = "WachtendOpActivatie",
  ActieveScholenMetRecenteLes = "ActieveScholenMetRecenteLes",
  OpenTickets = "OpenTickets",
  Abonnementen = "Abonnementen",
  NieuweScholen = "NieuweScholen",
  ShowcaseScholen = "ShowcaseScholen",
  OpenstaandeInvites = "OpenstaandeInvites",
  MediaanDagenTotEersteLes = "MediaanDagenTotEersteLes",
  ActieveDocenten = "ActieveDocenten",
  ScholenZonderLeerlingen = "ScholenZonderLeerlingen",
}

export interface AnnuleerLesCommand {
  lesId: string;
}

export enum AnnuleerLesErrors {
  LesNotActief = "LesNotActief",
}

export interface AssignTicketAdminRequest {
  userId?: string | null;
}

export enum AssignTicketErrors {
  AssigneeNotAdmin = "AssigneeNotAdmin",
}

export enum AvatarCategorie {
  Man = "Man",
  Vrouw = "Vrouw",
  Unisex = "Unisex",
}

export interface BeoordelingsschaalDetailModel {
  id?: string | null;
  lowerBound: number;
  upperBound: number;
}

export interface BeoordelingsschaalExportDto {
  id: string;
  lowerBound: number;
  upperBound: number;
  niveau: number;
}

export interface BeoordelingsschaalLesModel {
  lowerBound: number;
  upperBound: number;
}

export interface BeweegactiviteitDetailModel {
  id?: string | null;
  name: string;
  beweegthema?: Beweegthema;
  leerjaarCombo: LeerjaarCombo;
  icon?: IconModel;
  type: BeweegactiviteitType;
  beweegdoelen?: BeweegdoelDetailModel[] | null;
  vrijBeweegdoel?: VrijBeweegdoelDetailModel;
  readonly maxNiveau: number;
  voorbereiding?: string | null;
  benodigdMateriaal?: string | null;
  aandachtspunten?: string | null;
  opstellingsfotos?: FileModel[] | null;
}

export interface BeweegactiviteitExportDto {
  id: string;
  name: string;
  leerjaarCombo: LeerjaarCombo;
  voorbereiding?: string | null;
  benodigdMateriaal?: string | null;
  aandachtspunten?: string | null;
  opstellingsfotos?: OpstellingsfotoExportDto[] | null;
  icon?: IconExportDto;
  versie: BeweegactiviteitversieExportDto;
}

export interface BeweegactiviteitLesModel {
  id?: string | null;
  name: string;
  type: BeweegactiviteitType;
  leerjaarCombo: LeerjaarCombo;
  icon?: IconModel;
  beweegdoelen?: BeweegdoelDetailModel[] | null;
  vrijBeweegdoel?: VrijBeweegdoelLesModel;
}

export interface BeweegactiviteitPrecheckModel {
  beweegactiviteitId: string;
  name: string;
  leerjaarCombo: LeerjaarCombo;
  leerlingenWithoutResultaat: string[];
}

export interface BeweegactiviteitSelectieModel {
  id: string;
  leerjaarCombo: LeerjaarCombo;
  name: string;
}

export interface BeweegactiviteitToRemoveModel {
  beweegactiviteitId: string;
  name: string;
  leerjaarCombo: LeerjaarCombo;
  leerlingen: string[];
}

export enum BeweegactiviteitType {
  Gerangschikt = "Gerangschikt",
  VrijBeweegdoel = "VrijBeweegdoel",
  Meerkeuze = "Meerkeuze",
}

export interface BeweegactiviteitenSelectieModel {
  beweegactiviteitEenTwee?: BeweegactiviteitSelectieModel;
  beweegactiviteitDrieVier?: BeweegactiviteitSelectieModel;
  beweegactiviteitVijfZes?: BeweegactiviteitSelectieModel;
  beweegactiviteitZevenAcht?: BeweegactiviteitSelectieModel;
}

export interface BeweegactiviteitenreeksAdminOverviewModel {
  schoolId?: string | null;
  schoolName: string;
  id: string;
  name: string;
  leerlijn: Leerlijn;
  beweegthema: Beweegthema;
  isDefault: boolean;
  isPublished: boolean;
  leerjaarCombo: LeerjaarCombo[];
  canTogglePublished: boolean;
}

export interface BeweegactiviteitenreeksCreatedEvent {
  schoolId: string;
  id: string;
}

export interface BeweegactiviteitenreeksDeletedEvent {
  schoolId: string;
  deletedIds: string[];
}

export interface BeweegactiviteitenreeksDetailModel {
  id?: string | null;
  name: string;
  beweegthema: Beweegthema;
  isDefault?: boolean | null;
  isPublished?: boolean | null;
  canTogglePublished: boolean;
  beweegactiviteitEenTwee?: BeweegactiviteitDetailModel;
  beweegactiviteitDrieVier?: BeweegactiviteitDetailModel;
  beweegactiviteitVijfZes?: BeweegactiviteitDetailModel;
  beweegactiviteitZevenAcht?: BeweegactiviteitDetailModel;
}

export interface BeweegactiviteitenreeksExportDto {
  id: string;
  name: string;
  leerlijn: Leerlijn;
  beweegthema: Beweegthema;
  isDefault: boolean;
  isPublished: boolean;
  beweegactiviteiten: BeweegactiviteitExportDto[];
}

export interface BeweegactiviteitenreeksOverviewModel {
  id: string;
  name: string;
  leerlijn: Leerlijn;
  beweegthema: Beweegthema;
  isDefault: boolean;
  isPublished: boolean;
  leerjaarCombo: LeerjaarCombo[];
  canTogglePublished: boolean;
}

export interface BeweegactiviteitenreeksSelectieModel {
  id: string;
  name: string;
  isDefault: boolean;
  beweegactiviteiten: BeweegactiviteitenSelectieModel;
}

export interface BeweegactiviteitenreeksUpdatedEvent {
  schoolId: string;
  id: string;
}

export interface BeweegactiviteitversieExportDto {
  id: string;
  version: number;
  type: BeweegactiviteitType;
  beweegdoelen?: BeweegdoelExportDto[] | null;
  vrijBeweegdoel?: VrijBeweegdoelExportDto;
}

export interface BeweegdoelDetailModel {
  id?: string | null;
  description: string;
  niveau?: number | null;
  instructiefotos?: FileModel[] | null;
}

export interface BeweegdoelExportDto {
  id: string;
  description: string;
  order: number;
  instructiefotos?: InstructiefotoExportDto[] | null;
}

export interface BeweegresultaatDocentModel {
  lesId: string;
  leerlingId: string;
  beweegactiviteitId: string;
  behaaldNiveau?: number | null;
  behaaldWaarde?: number | null;
  behaaldChangedAt?: Date | null;
  opmerking?: string | null;
  historie?: BeweegresultaatDocentModel;
  maxNiveau?: number | null;
  leerlingLeerjaar: Leerjaar;
  beweegactiviteitLeerjaarCombo: LeerjaarCombo;
  behaaldeBeweegdoelIds: string[];
  readonly isOverachieved: boolean;
}

export interface BeweegresultaatModel {
  lesId: string;
  leerlingId: string;
  beweegactiviteitId: string;
  behaaldNiveau?: number | null;
  behaaldWaarde?: number | null;
  behaaldChangedAt?: Date | null;
  previousNiveau?: number | null;
  previousWaarde?: number | null;
  opmerking?: string | null;
  behaaldeBeweegdoelIds: string[];
  previousBehaaldeBeweegdoelIds?: string[] | null;
}

export interface BeweegresultaatOpmerkingUpdatedEvent {
  lesId: string;
  leerlingId: string;
  beweegactiviteitId: string;
}

export interface BeweegresultaatSentenceModel {
  beweegactiviteitId: string;
  sentence: string;
  resultaatType: ResultaatType;
}

export interface BeweegresultaatUpdatedEvent {
  schoolId: string;
  lesId: string;
  leerlingId: string;
}

export enum Beweegthema {
  Balanceren = "Balanceren",
  Rijden = "Rijden",
  Glijden = "Glijden",
  Acrobatiek = "Acrobatiek",
  Klauteren = "Klauteren",
  Touwklimmen = "Touwklimmen",
  Schommelen = "Schommelen",
  HangendZwaaien = "HangendZwaaien",
  SteunendZwaaien = "SteunendZwaaien",
  OverDeKopGaan = "OverDeKopGaan",
  VrijeSprongen = "VrijeSprongen",
  Steunspringen = "Steunspringen",
  HoogEnVerspringen = "HoogEnVerspringen",
  TouwtjeSpringen = "TouwtjeSpringen",
  Hardlopen = "Hardlopen",
  HardlopenCoopertest = "HardlopenCoopertest",
  Wegspelen = "Wegspelen",
  Mikken = "Mikken",
  WerpenEnVangen = "WerpenEnVangen",
  Soleren = "Soleren",
  Retourneren = "Retourneren",
  Doelspelen = "Doelspelen",
  Lummelspelen = "Lummelspelen",
  AangepasteSportspelen = "AangepasteSportspelen",
  Keeperspelen = "Keeperspelen",
  Tikspelen = "Tikspelen",
  Afgooispelen = "Afgooispelen",
  Honkloopspelen = "Honkloopspelen",
  Stoeispelen = "Stoeispelen",
  EenDansUitvoeren = "EenDansUitvoeren",
}

export interface BeweegthemaAverageModel {
  beweegthema: Beweegthema;
  average: number;
  containsOverachieved: boolean;
  readonly displayAverage: number;
}

export interface BeweegthemaChartData {
  thema: Beweegthema;
  value: number;
  trend: StatistiekTrend;
}

export interface BeweegthemaSelectieModel {
  beweegthema: Beweegthema;
  beweegactiviteitenreeksen: BeweegactiviteitenreeksSelectieModel[];
}

export enum CloseTicketErrors {
  NotAllowedWhileImpersonating = "NotAllowedWhileImpersonating",
}

export enum ConfirmEmailChangeErrors {
  EmailConfirmationFailed = "EmailConfirmationFailed",
}

export interface ConfirmEmailChangeRequest {
  email: string;
  token: string;
}

export enum ConfirmEmailErrors {
  EmailConfirmationFailed = "EmailConfirmationFailed",
  EmailAlreadyConfirmed = "EmailAlreadyConfirmed",
}

export interface ConfirmEmailRequest {
  email: string;
  token: string;
}

export interface CreateBeweegactiviteitenreeksAdminCommand {
  beweegactiviteitenreeks: BeweegactiviteitenreeksDetailModel;
}

export interface CreateBeweegactiviteitenreeksCommand {
  beweegactiviteitenreeks: BeweegactiviteitenreeksDetailModel;
}

export enum CreateBeweegactiviteitenreeksErrors {
  InvalidBeoordelingsschaal = "InvalidBeoordelingsschaal",
  BeweegdoelRequired = "BeweegdoelRequired",
}

export enum CreateInvitationErrors {
  InviteAlreadyExists = "InviteAlreadyExists",
  InviteeIsAdmin = "InviteeIsAdmin",
  MaxDocentenReached = "MaxDocentenReached",
}

export interface CreateKlasCommand {
  name: string;
  leerjaren: Leerjaar[];
}

export enum CreateKlasErrors {
  KlasAlreadyExists = "KlasAlreadyExists",
}

export interface CreateLeerlingCommand {
  studentNumber: string;
  firstName: string;
  lastName: string;
  birthDate: Date;
  gender: Gender;
  klasId: string;
  leerjaren: Leerjaar[];
  avatarNummer: number;
}

export enum CreateLeerlingErrors {
  LeerlingAlreadyExists = "LeerlingAlreadyExists",
}

export interface CreateLesCommand {
  klasIds: string[];
  beweegactiviteiten: string[];
  sociaalEmotioneelThemas: string[];
  filter: LesgroepenFilterModel;
  isConcept: boolean;
  startedAt?: Date | null;
}

export enum CreateLesErrors {
  NoLeerlingenFoundForLes = "NoLeerlingenFoundForLes",
}

export interface CreateRapportCommand {
  from: Date;
  to: Date;
  name?: string | null;
  klassen: string[];
}

export interface CreateSchoolAdminCommand {
  name: string;
  alias?: string | null;
  brin?: string | null;
  address: string;
  houseNumber: string;
  postalCode: string;
  city: string;
  phoneNumber: string;
  bestuursnummer?: string | null;
  bestuursnaam?: string | null;
  licentieType: LicentieType;
  endDate?: Date | null;
}

export enum CreateSchoolErrors {
  SchoolAlreadyExists = "SchoolAlreadyExists",
}

export interface CreateSchooldocentInviteAdminCommand {
  schoolId: string;
  inviteeEmail: string;
}

export interface CreateSchooldocentInviteCommand {
  schoolId: string;
  inviteeEmail: string;
}

export interface CreateSociaalEmotioneelThemasReeksAdminCommand {
  sociaalEmotioneelThemasReeks: SociaalEmotioneelThemasReeksDetailModel;
}

export interface CreateSociaalEmotioneelThemasReeksCommand {
  sociaalEmotioneelThemasReeks: SociaalEmotioneelThemasReeksDetailModel;
}

export enum CreateSociaalEmotioneelThemasReeksErrors {
  MinimumThreeSociaalEmotioneelDoelenRequired = "MinimumThreeSociaalEmotioneelDoelenRequired",
  MaximumFiveSociaalEmotioneelDoelenAllowed = "MaximumFiveSociaalEmotioneelDoelenAllowed",
}

export interface CreateTicketCommand {
  subject: string;
  type: TicketType;
  content: string;
  fileIds: string[];
}

export enum CreateTicketErrors {
  NotAllowedWhileImpersonating = "NotAllowedWhileImpersonating",
  TooManyAttachments = "TooManyAttachments",
}

export interface CreateTicketResponse {
  id: string;
  ticketNumber: number;
}

export interface CurrentSchooljaar {
  fromYear: number;
  toYear: number;
}

export interface DatabaseExportedEvent {
  blobName: string;
  blobUri: string;
  fileSize: number;
}

export interface DateTimeNullableParsedField {
  value?: Date | null;
  oldValue?: Date | null;
  validationStatus: FieldValidationType;
  validationCode?: ParsingValidationErrorCode;
  readonly isValid: boolean;
  readonly hasChanged: boolean;
}

export interface DeadLetterAdminModel {
  id: string;
  messageType: string;
  exceptionType: string;
  exceptionMessage: string;
  sentAt: Date;
  replayable: boolean;
  messageJson: string;
}

export interface DeleteDeadLettersAdminCommand {
  ids: string[];
}

export interface DeleteKlasCommand {
  klasId: string;
}

export enum DeleteKlasErrors {
  HasActiveInschrijvingen = "HasActiveInschrijvingen",
}

export interface DeleteLeerlingCommand {
  leerlingId: string;
}

export enum DeleteMessageErrors {
  NotAllowedWhileImpersonating = "NotAllowedWhileImpersonating",
  CannotDeleteFirstMessage = "CannotDeleteFirstMessage",
  OnlyLatestMessageDeletable = "OnlyLatestMessageDeletable",
}

export interface DeleteNotitieCommand {
  id: string;
  notitieType: NotitieType;
  leerlingId?: string | null;
}

export interface DeletePasskeyRequest {
  credentialId: string;
}

export interface DeleteSchoolAdminCommand {
  schoolId: string;
}

export interface DeleteSchooldocentInviteAdminCommand {
  inviteId: string;
}

export interface DeleteSchooldocentInviteCommand {
  inviteId: string;
}

export enum Disable2FAErrors {
  InvalidCredentials = "InvalidCredentials",
}

export interface Disable2FARequest {
  password: string;
}

export interface DocentInviteEmailProps {
  schoolName: string;
  inviteLink: string;
}

export interface DocentOverviewAdminModel {
  docentId: string;
  userId: string;
  createdAt: Date;
  name: string;
  email: string;
  scholen: string[];
  isHoofdDocent: boolean;
  isBlocked: boolean;
  has2FaEnabled: boolean;
  lastActivityAt?: Date | null;
  readonly canBeRemoved: boolean;
  readonly canBeMadeHoofdDocent: boolean;
  readonly canBeBlocked: boolean;
  readonly canReset2Fa: boolean;
}

export interface DocentOverviewModel {
  schooldocentId: string;
  userId: string;
  name: string;
  email: string;
  currentDocenten: number;
  maxDocenten: number;
  isHoofdDocent: boolean;
  isBlocked: boolean;
  loggedInUserIsHoofdDocent: boolean;
  lastActivityAt?: Date | null;
  readonly canBeRemoved: boolean;
  readonly canBeMadeHoofdDocent: boolean;
  readonly canBeBlocked: boolean;
}

export interface DocentRemovedEmailProps {
  firstname: string;
  schoolName: string;
}

export interface DomeinFilterSelectionModel {
  selectedDomeinFilterIds: string[];
}

export interface DomeinKolom {
  combo: LeerjaarCombo;
  value: number;
  trend: StatistiekTrend;
}

export interface DomeinSelectieModel {
  domein: SociaalEmotioneelDomein;
  sociaalEmotioneelThemasReeksen: SociaalEmotioneelThemasReeksSelectieModel[];
}

export interface DomeinSnapshotData {
  domein: SociaalEmotioneelDomein;
  kolommen: DomeinKolom[];
}

export enum EditMessageErrors {
  NotAllowedWhileImpersonating = "NotAllowedWhileImpersonating",
}

export interface EditTicketMessageRequest {
  content: string;
  fileIds: string[];
}

export interface EmailChangedEmailProps {
  confirmationLink: string;
}

export enum EmailType {
  SchoolTrialEmail = "SchoolTrialEmail",
  SchoolTrialExpirationReminder10DaysEmail = "SchoolTrialExpirationReminder10DaysEmail",
  SchoolTrialExpirationReminder5DayEmail = "SchoolTrialExpirationReminder5DayEmail",
  SchoolTrialExpiredEmail = "SchoolTrialExpiredEmail",
  SchoolSubscriptionEmail = "SchoolSubscriptionEmail",
  SchoolReadyForUseEmail = "SchoolReadyForUseEmail",
  UserConfirmationEmail = "UserConfirmationEmail",
  EmailChangedEmail = "EmailChangedEmail",
  PasswordResetEmail = "PasswordResetEmail",
  UserRemovedEmail = "UserRemovedEmail",
  DocentInviteEmail = "DocentInviteEmail",
  DocentRemovedEmail = "DocentRemovedEmail",
  TicketNotificationEmail = "TicketNotificationEmail",
  InternalSchoolTrialEmail = "InternalSchoolTrialEmail",
  InternalSchoolSubscriptionEmail = "InternalSchoolSubscriptionEmail",
}

export interface ExportBeweegactiviteitenreeksenResponse {
  beweegactiviteitenreeksen: BeweegactiviteitenreeksExportDto[];
}

export interface ExportSociaalEmotioneelThemasReeksenResponse {
  sociaalEmotioneelThemasReeksen: SociaalEmotioneelThemasReeksExportDto[];
}

export interface ExportSportenResponse {
  sporten: SportExportDto[];
}

export enum FieldValidationType {
  Valid = "Valid",
  Error = "Error",
}

export interface FietsvaardigheidModel {
  inProgress: boolean;
  ikKanFietsen: boolean;
  kanNietFietsen: boolean;
}

export interface FileDeletedEvent {
  fileId: string;
}

export interface FileModel {
  id: string;
  fileName: string;
  contentType: string;
  fileSize: number;
}

export enum FilterProgressStatus {
  None = "None",
  InProgress = "InProgress",
  Completed = "Completed",
}

export interface FilterTreeItemModel {
  id: string;
  name: string;
  enabled: boolean;
  hasProgress: boolean;
  visible: boolean;
  childrenMaxProgressCount?: number | null;
  children: FilterTreeItemModel[];
  readonly childrenCount: number;
  readonly enabledChildrenCount: number;
  readonly progressChildrenCount: number;
  progressStatus: FilterProgressStatus;
  readonly progress: string;
  readonly showProgress: boolean;
  readonly endOfDepth: boolean;
}

export interface FilterTreeModel {
  items: FilterTreeItemModel[];
  readonly selectedFilterIds: string[];
}

export enum FindSchoolByBrinErrors {
  SchoolAlreadyExists = "SchoolAlreadyExists",
}

export interface ForgotPasswordRequest {
  email: string;
}

export enum Gender {
  Man = "Man",
  Vrouw = "Vrouw",
}

export interface GenerateSchoolAliasAdminResponse {
  alias: string;
}

export enum Get2FASetupErrors {
  TwoFactorAlreadyEnabled = "TwoFactorAlreadyEnabled",
}

export interface GetBeweegactiviteitenreeksDetailResponse {
  beweegactiviteitenreeks: BeweegactiviteitenreeksDetailModel;
}

export interface GetBeweegactiviteitenreeksenAdminResponse {
  count: number;
  data: BeweegactiviteitenreeksAdminOverviewModel[];
  filters: GetBeweegactiviteitenreeksenAdminResponseFilter;
}

export interface GetBeweegactiviteitenreeksenAdminResponseFilter {
  schoolIds: (string | null)[];
  leerlijnen: Leerlijn[];
  beweegthemas: Beweegthema[];
  leerjaarCombos: LeerjaarCombo[];
}

export interface GetBeweegactiviteitenreeksenForLesResponse {
  leerlijnen: LeerlijnSelectieModel[];
}

export interface GetBeweegactiviteitenreeksenResponse {
  count: number;
  data: BeweegactiviteitenreeksOverviewModel[];
  filters: GetBeweegactiviteitenreeksenResponseFilter;
}

export interface GetBeweegactiviteitenreeksenResponseFilter {
  leerlijnen: Leerlijn[];
  beweegthemas: Beweegthema[];
  leerjaarCombos: LeerjaarCombo[];
}

export interface GetBeweegthemasForLesResponse {
  beweegthemas: Beweegthema[];
}

export interface GetDeadLettersAdminResponse {
  totalCount: number;
  deadLetters: DeadLetterAdminModel[];
}

export interface GetDocentenForSchoolAdminResponse {
  docenten: DocentOverviewAdminModel[];
}

export interface GetDocentenResponse {
  docenten: DocentOverviewModel[];
  canAddDocent: boolean;
  currentDocenten: number;
  maxDocenten: number;
}

export interface GetKlasAvatarsResponse {
  avatars: KlasAvatarModel[];
}

export interface GetKlasBeweegactiviteitenProgressDetailResponse {
  leerlingen: KlasBeweegactiviteitProgressDetailModel[];
}

export interface GetKlasBeweegactiviteitenProgressResponse {
  beweegactiviteitProgressItems: KlasBeweegactiviteitProgressModel[];
  leerlijnFilter: FilterTreeModel;
}

export interface GetKlasDetailResponse {
  klas: KlasDetailModel;
}

export interface GetKlasLeerlijnAveragesResponse {
  leerlingen: LeerlingLeerlijnAverageModel[];
  leerjaren: Leerjaar[];
  leerjaar: Leerjaar;
}

export interface GetKlasSociaalEmotioneelThemaDomeinAveragesResponse {
  leerlingen: LeerlingSociaalEmotioneelThemaDomeinAverageModel[];
  leerjaren: Leerjaar[];
  leerjaar: Leerjaar;
}

export interface GetKlassenResponse {
  count: number;
  data: KlasOverviewModel[];
}

export interface GetLeerlingBeweegactiviteitenProgressResponse {
  beweegactiviteitProgressItems: LeerlingBeweegactiviteitProgressModel[];
  leerlijnFilter: FilterTreeModel;
}

export interface GetLeerlingBeweegresultatenHistorieResponse {
  beweegactiviteitName?: string | null;
  beweegactiviteiten: BeweegactiviteitDetailModel[];
  beweegresultaten: BeweegresultaatDocentModel[];
}

export interface GetLeerlingDashboardResponse {
  statistieken: LeerlingStatistiekenModel;
  latestNotities: NotitieModel[];
  latestBeweegactiviteiten: LeerlingBeweegactiviteitProgressModel[];
  latestSociaalEmotioneelThemas: LeerlingSociaalEmotioneelThemaProgressModel[];
  latestRapporten: RapportOverviewModel[];
}

export interface GetLeerlingDetailResponse {
  leerling: LeerlingDetailModel;
}

export interface GetLeerlingLeerlijnAveragesResponse {
  leerling: LeerlingLeerlijnAverageModel;
  leerjaren: Leerjaar[];
  leerjaar?: Leerjaar;
}

export interface GetLeerlingNotitiesResponse {
  count: number;
  data: NotitieModel[];
  leerlingNaam: string;
}

export interface GetLeerlingSociaalEmotioneelThemaDomeinAveragesResponse {
  averages: LeerlingSociaalEmotioneelThemaDomeinAverageModel;
  leerjaren: Leerjaar[];
  leerjaar?: Leerjaar;
}

export interface GetLeerlingSociaalEmotioneelThemaResultatenHistorieResponse {
  sociaalEmotioneelThemaName?: string | null;
  sociaalEmotioneelThemas: SociaalEmotioneelThemaDetailModel[];
  sociaalEmotioneelResultaten: SociaalEmotioneelResultaatHistorieModel[];
}

export interface GetLeerlingSociaalEmotioneelThemasProgressResponse {
  sociaalEmotioneelThemaProgressItems: LeerlingSociaalEmotioneelThemaProgressModel[];
  domeinFilter: FilterTreeModel;
}

export interface GetLeerlingSportdeelnameResponse {
  sportdeelname: SportdeelnameModel;
  sporten: SportModel[];
  verenigingen: VerenigingModel[];
}

export interface GetLeerlingStatistiekenResponse {
  snapshots: LeerjaarSnapshot[];
  leerlijnFilter: FilterTreeModel;
  domeinFilter: FilterTreeModel;
  currentLeerjaar: Leerjaar;
}

export interface GetLeerlingenResponse {
  count: number;
  data: LeerlingOverviewModel[];
}

export interface GetLesDocentgestuurdResponse {
  klasName: string;
  status: LesStatus;
  canBeStarted: boolean;
  canBeEdited: boolean;
  date: Date;
  aantalGroepen: number;
  groepeerType: GroepeerType;
  beweegactiviteiten: string[];
  sociaalEmotioneelThemas: string[];
  avatarsEnabled: boolean;
  aantalLeerlingen: number;
  aantalAanwezig?: number | null;
  readonly isAdministratieLes: boolean;
}

export interface GetLesEditDataResponse {
  status: LesStatus;
  date: Date;
  klasIds: string[];
  beweegactiviteiten: string[];
  sociaalEmotioneelThemas: string[];
  filter: LesgroepenFilterModel;
  lesgroepen: LesgroepModel[];
  readonly canEditDate: boolean;
}

export interface GetLesInformatieResponse {
  beweegactiviteiten: BeweegactiviteitDetailModel[];
  sociaalEmotioneelThemas: SociaalEmotioneelThemaDetailModel[];
}

export interface GetLesLeerlinggestuurdResponse {
  klasName: string;
  lesgroepen: LesgroepModel[];
  beweegactiviteiten: BeweegactiviteitLesModel[];
  sociaalEmotioneelThemas: SociaalEmotioneelThemaDetailModel[];
  beweegresultaten: BeweegresultaatModel[];
  sociaalEmotioneelResultaten: SociaalEmotioneelResultaatModel[];
  avatarsEnabled: boolean;
}

export interface GetLesNotitiesResponse {
  lesNotitie?: LesNotitieModel;
  relatedNotities: LesNotitieModel[];
}

export interface GetLesSportdeelnamesResponse {
  groupedSportdeelnames: GroupedSportdeelnameModel[];
  sporten: SportModel[];
  verenigingen: VerenigingModel[];
}

export interface GetLesadministratieLeerlingTimeoutsResponse {
  leerlingId: string;
  naam: string;
  timeouts: LeerlingTimeoutModel[];
}

export interface GetLesadministratieStatistiekLeerlingenResponse {
  totalLeerlingen: number;
  leerlingen: LesadministratieStatistiekenLeerling[];
}

export interface GetLesadministratieStatistiekenResponse {
  totalLeerlingen: number;
  afwezigheden: LesadministratieCountModel;
  blessures: LesadministratieCountModel;
  gymkledingVergeten: LesadministratieCountModel;
  disciplinaireMaatregel: LesadministratieCountModel;
  leerlingen: LesadministratieStatistiekenLeerling[];
}

export interface GetLesadministratiesResponse {
  groupedLesadministraties: GroupedLesadministratieModel[];
}

export interface GetLesgroepenForLesQuery {
  klasIds: string[];
  filter: LesgroepenFilterModel;
}

export interface GetLesgroepenForLesResponse {
  lesgroepen: LesgroepModel[];
}

export interface GetLesresultatenResponse {
  groupedLeerlingen: GroupedLeerlingResultaatModel[];
  beweegactiviteiten: BeweegactiviteitDetailModel[];
  sociaalEmotioneelThemas: SociaalEmotioneelThemaDetailModel[];
}

export interface GetLessenResponse {
  count: number;
  data: LesOverviewModel[];
}

export enum GetPasskeySetupErrors {
  TwoFactorNotEnabled = "TwoFactorNotEnabled",
}

export interface GetPasskeysResponse {
  passkeys: PasskeyModel[];
}

export interface GetRapportLeerlingResultatenResponse {
  leerlingen: LeerlingRapportModel[];
  filter: RapportFilterModel;
  groupedLeerlingen: GroupedLeerlingSelectionModel[];
}

export interface GetRapportNotitiesResponse {
  groupedNotities: GroupedRapportNotitieModel[];
}

export interface GetRapportResponse {
  name?: string | null;
  from: Date;
  to: Date;
  klassen: KlasListModel[];
  rapportElementen?: RapportElementen[] | null;
  logoId?: string | null;
}

export interface GetRapportenResponse {
  count: number;
  data: RapportOverviewModel[];
}

export interface GetScholenAdminResponse {
  count: number;
  data: SchoolAdminOverviewModel[];
}

export interface GetSchoolBySlugResponse {
  school: SchoolDetailModel;
  canEdit: boolean;
}

export interface GetSchoolDetailAdminResponse {
  school: SchoolDetailAdminModel;
  kpis: SchoolKpiAdminModel;
}

export interface GetSchoolMetadataResponse {
  name: string;
  currentSchooljaar: CurrentSchooljaar;
  licentieType: LicentieType;
  showImportReminder: boolean;
  isAllowedToImport: boolean;
  showSubscriptionReminder: boolean;
  subscriptionInProgress: boolean;
  isZuurpruim: boolean;
}

export interface GetSchooldocentInvitesAdminResponse {
  invites: SchooldocentInviteOverviewModel[];
  canAddDocent: boolean;
}

export interface GetSchooldocentInvitesResponse {
  invites: SchooldocentInviteOverviewModel[];
  isHoofddocent: boolean;
  canAddDocent: boolean;
}

export interface GetSchooljarenAdminResponse {
  schooljaren: SchooljaarAdminModel[];
}

export interface GetSociaalEmotioneelThemasReeksDetailResponse {
  sociaalEmotioneelThemasReeks: SociaalEmotioneelThemasReeksDetailModel;
}

export interface GetSociaalEmotioneelThemasReeksenAdminResponse {
  count: number;
  data: SociaalEmotioneelThemasReeksAdminOverviewModel[];
  filters: GetSociaalEmotioneelThemasReeksenAdminResponseFilter;
}

export interface GetSociaalEmotioneelThemasReeksenAdminResponseFilter {
  schoolIds: (string | null)[];
  domeinen: SociaalEmotioneelDomein[];
  leerjaarCombos: LeerjaarCombo[];
}

export interface GetSociaalEmotioneelThemasReeksenForLesResponse {
  domeinen: DomeinSelectieModel[];
}

export interface GetSociaalEmotioneelThemasReeksenResponse {
  count: number;
  data: SociaalEmotioneelThemasReeksOverviewModel[];
  filters: GetSociaalEmotioneelThemasReeksenResponseFilter;
}

export interface GetSociaalEmotioneelThemasReeksenResponseFilter {
  domeinen: SociaalEmotioneelDomein[];
  leerjaarCombos: LeerjaarCombo[];
}

export interface GetSportdeelnameStatistiekLeerlingenResponse {
  totalLeerlingen: number;
  leerlingen: SportdeelnameStatistiekenLeerling[];
}

export interface GetSportdeelnameStatistiekenResponse {
  totalLeerlingen: number;
  leerlingenMetSport: number;
  geenZwemdiploma: SportdeelnameCountModel;
  zonderSport: SportdeelnameCountModel;
  motorischeZorg: SportdeelnameCountModel;
  zonderSportEnZonderDiploma: SportdeelnameCountModel;
  kanNietFietsen: SportdeelnameCountModel;
  zwemvaardigheden: SportdeelnameChartData[];
  populaireSporten: SportdeelnameChartData[];
  topWensSporten: SportdeelnameChartData[];
  leerlingen: SportdeelnameStatistiekenLeerling[];
}

export interface GetSportdeelnameTrendResponse {
  punten: SportdeelnameTrendPunt[];
}

export interface GetSportenQuery {}

export interface GetSportenResponse {
  sporten: SportModel[];
}

export interface GetStatisticsHistoryAdminResponse {
  stat: AdminStatHistorySoort;
  points: WeekCountAdminModel[];
}

export interface GetStatisticsOverviewAdminResponse {
  licenties: LicentieCountsAdminModel;
  actieveScholen: number;
  actieveScholenMetRecenteLes: number;
  geactiveerdeScholen: number;
  scholenMetLeerlingen: number;
  scholenZonderLeerlingen: number;
  wachtendOpActivatie: number;
  nieuweScholenLaatste48Uur: number;
  wekelijksActieveUsers: number;
  totaalLeerlingen: number;
  totaalLessenGegeven: number;
  totaalScores: number;
  tickets: TicketStatsAdminModel;
  pendingInvites: InviteAgingAdminModel;
  mediaanDagenTotEersteLes?: number | null;
}

export interface GetStatisticsTrendsAdminResponse {
  lessenAfgerondPerWeek: WeekCountAdminModel[];
  resultatenPerWeek: WeekResultatenAdminModel[];
  nieuweScholenPerMaand: MaandCountAdminModel[];
}

export interface GetSystemNotificationAdminResponse {
  active?: SystemNotificationModel | null;
}

export interface GetTicketAssigneesAdminResponse {
  assignees: TicketAssigneeModel[];
}

export interface GetTicketsAdminResponse {
  count: number;
  data: TicketAdminOverviewModel[];
}

export interface GetTicketsResponse {
  tickets: TicketOverviewModel[];
}

export interface GetUnreadTicketCountAdminResponse {
  count: number;
}

export enum GetUserMetadataErrors {
  UserIsBlocked = "UserIsBlocked",
}

export interface GetUserMetadataResponse {
  scholen: SchoolSelectModel[];
  activeLessen: ActiveLesModel[];
  lastSelectedSchoolSlug?: string | null;
  requires2FA: boolean;
  has2FAEnabled: boolean;
  hasReadLatestReleaseNotes: boolean;
  hasSeenOnboarding: boolean;
  unreadTicketCount: number;
  defaultAantalGroepen?: number | null;
  lastSeenSystemNotificationId?: string | null;
  systemNotification?: SystemNotificationModel | null;
}

export interface GetUsersResponse {
  count: number;
  data: DocentOverviewAdminModel[];
}

export enum GroepeerType {
  Homogeen = "Homogeen",
  Heterogeen = "Heterogeen",
}

export interface GroupedBeweegresultaatSentenceModel {
  leerlijn: Leerlijn;
  sentences: BeweegresultaatSentenceModel[];
}

export interface GroupedLeerlingResultaatModel {
  groep: number;
  leerlingen: LeerlingResultaatModel[];
}

export interface GroupedLeerlingSelectionModel {
  klasNaam: string;
  leerlingen: LeerlingSelectionModel[];
}

export interface GroupedLesadministratieModel {
  groep: number;
  lesadministraties: LesadministratieModel[];
}

export interface GroupedRapportNotitieModel {
  klasNaam: string;
  notities: RapportNotitieModel[];
}

export interface GroupedSociaalEmotioneelResultaatSentenceModel {
  domein: SociaalEmotioneelDomein;
  sentences: SociaalEmotioneelResultaatSentenceModel[];
}

export interface GroupedSportdeelnameModel {
  groep: number;
  sportdeelnames: SportdeelnameModel[];
}

export interface IconExportDto {
  id: string;
  svg: string;
}

export interface IconModel {
  id: string;
  svg: string;
}

export interface ImportLeerlingenCommand {
  klassen: KlasParseModel[];
  schoolverlaters: LeerlingParseModel[];
  zittenblijvers: LeerlingParseModel[];
  doorstromers: LeerlingParseModel[];
  newLeerlingen: LeerlingParseModel[];
  editedLeerlingen: LeerlingParseModel[];
  allowDeletes: boolean;
  createNewSchooljaar: boolean;
}

export enum ImportLeerlingenErrors {
  KlasAlreadyExists = "KlasAlreadyExists",
  HasActiveInschrijvingen = "HasActiveInschrijvingen",
  LeerlingAlreadyExists = "LeerlingAlreadyExists",
  VerwerkersovereenkomstRequired = "VerwerkersovereenkomstRequired",
}

export interface InstructiefotoExportDto {
  id: string;
  fileId: string;
  fileName: string;
  blobName: string;
  contentType: string;
  fileSize: number;
  order: number;
}

export interface Int32NullableListParsedField {
  value?: (number | null)[] | null;
  oldValue?: (number | null)[] | null;
  validationStatus: FieldValidationType;
  validationCode?: ParsingValidationErrorCode;
  readonly isValid: boolean;
  readonly hasChanged: boolean;
}

export interface Int32NullableParsedField {
  value?: number | null;
  oldValue?: number | null;
  validationStatus: FieldValidationType;
  validationCode?: ParsingValidationErrorCode;
  readonly isValid: boolean;
  readonly hasChanged: boolean;
}

export interface InternalSchoolSubscriptionEmailProps {
  name: string;
  email: string;
  brin: string;
  schoolName: string;
  city: string;
  address: string;
  houseNumber: string;
  postalCode: string;
  phoneNumber: string;
  bestuursnaam: string;
  dashboardUrl: string;
}

export interface InternalSchoolTrialEmailProps {
  name: string;
  email: string;
  brin: string;
  schoolName: string;
  city: string;
  address: string;
  houseNumber: string;
  postalCode: string;
  phoneNumber: string;
  bestuursnaam: string;
  expirationDate: Date;
}

export interface InviteAgingAdminModel {
  totaal: number;
  totZevenDagen: number;
  zevenTotDertigDagen: number;
  ouderDanDertigDagen: number;
  verlopen: number;
}

export interface InviteMailDeliveryModel {
  status: MailDeliveryStatus;
  statusAt?: Date | null;
  detail?: string | null;
}

export enum InviteStatus {
  Pending = "Pending",
  Accepted = "Accepted",
}

export enum InviteType {
  Docent = "Docent",
}

export interface KlasAvatarModel {
  avatarNummer: number;
  categorie: AvatarCategorie;
  inUse: boolean;
  leerlingName?: string | null;
}

export interface KlasBeweegactiviteitProgressDetailModel {
  leerlingId: string;
  displayName: string;
  behaaldNiveau?: number | null;
  maxNiveau?: number | null;
  readonly resultaat: string;
  readonly isMaxNiveau: boolean;
  lesId?: string | null;
}

export interface KlasBeweegactiviteitProgressModel {
  beweegactiviteitId: string;
  beweegactiviteitenReeksId: string;
  leerlijn: Leerlijn;
  beweegthema: Beweegthema;
  name: string;
  reeksName: string;
  leerlingenMetResultaat: number;
  totaalLeerlingen: number;
  readonly resultaten: string;
  progressStatus: ProgressStatus;
  isDefault: boolean;
  laatstBehandeld?: Date | null;
}

export interface KlasCreatedEvent {
  id: string;
}

export interface KlasDetailModel {
  id: string;
  name: string;
  leerjarenNumbers: number[];
  leerjaren: Leerjaar[];
  leerjaarCombos: LeerjaarCombo[];
  leerlingCount: number;
  leerlingen: KlasLeerlingModel[];
}

export interface KlasLeerlingModel {
  id: string;
  studentNumber: string;
  firstName: string;
  lastName: string;
  leerjaar: Leerjaar;
  avatarNummer: number;
}

export interface KlasListModel {
  id: string;
  name: string;
}

export interface KlasOverviewModel {
  id: string;
  name: string;
  leerjarenNumbers: number[];
  leerjaren: Leerjaar[];
  leerjaarCombos: LeerjaarCombo[];
  leerlingCount: number;
}

export interface KlasParseModel {
  klasName: StringParsedField;
  leerjaren: Int32NullableListParsedField;
  leerlingCount: number;
  status: KlasStatus;
  readonly isValid: boolean;
  readonly hasChanged: boolean;
}

export enum KlasStatus {
  New = "New",
  Updated = "Updated",
  Removed = "Removed",
  CannotBeRemoved = "CannotBeRemoved",
  Unchanged = "Unchanged",
}

export interface KlasUpdatedEvent {
  id: string;
}

export enum Leerjaar {
  None = "None",
  Een = "Een",
  Twee = "Twee",
  Drie = "Drie",
  Vier = "Vier",
  Vijf = "Vijf",
  Zes = "Zes",
  Zeven = "Zeven",
  Acht = "Acht",
}

export enum LeerjaarCombo {
  None = "None",
  EenTwee = "EenTwee",
  DrieVier = "DrieVier",
  VijfZes = "VijfZes",
  ZevenAcht = "ZevenAcht",
}

export interface LeerjaarSnapshot {
  leerjaar: Leerjaar;
  hasInschrijving: boolean;
  leerlijnen: LeerlijnSnapshotData[];
  domeinen: DomeinSnapshotData[];
}

export enum Leerlijn {
  Balanceren = "Balanceren",
  Klimmen = "Klimmen",
  Zwaaien = "Zwaaien",
  OverDeKopGaan = "OverDeKopGaan",
  Springen = "Springen",
  Hardlopen = "Hardlopen",
  Mikken = "Mikken",
  Jongleren = "Jongleren",
  Doelspelen = "Doelspelen",
  Tikspelen = "Tikspelen",
  Stoeispelen = "Stoeispelen",
  BewegenOpMuziek = "BewegenOpMuziek",
}

export interface LeerlijnAverageModel {
  leerlijn: Leerlijn;
  average: number;
  containsOverachieved: boolean;
  beweegthemaAverages: BeweegthemaAverageModel[];
  readonly displayAverage: number;
}

export interface LeerlijnFilterSelectionModel {
  selectedLeerlijnFilterIds: string[];
}

export interface LeerlijnSelectieModel {
  leerlijn: Leerlijn;
  beweegthemas: BeweegthemaSelectieModel[];
}

export interface LeerlijnSnapshotData {
  leerlijn: Leerlijn;
  kolommen: StatistiekKolom[];
}

export interface LeerlingBeweegactiviteitProgressModel {
  leerlingId: string;
  beweegactiviteitId: string;
  beweegactiviteitenReeksId: string;
  leerlijn: Leerlijn;
  beweegthema: Beweegthema;
  name: string;
  beweegactiviteitLeerjaarCombo: LeerjaarCombo;
  type: BeweegactiviteitType;
  leerlingLeerjaar: Leerjaar;
  behaaldNiveau: number;
  behaaldWaarde?: number | null;
  maxNiveau: number;
  behaaldAt?: Date | null;
  score: number;
  readonly resultaat: string;
  readonly isOverachieved: boolean;
  readonly isMaxNiveau: boolean;
}

export interface LeerlingCreatedEvent {
  id: string;
}

export interface LeerlingDetailModel {
  id: string;
  studentNumber: string;
  firstName: string;
  lastName: string;
  birthDate: Date;
  age: number;
  gender: Gender;
  leerjaar: Leerjaar;
  klasId: string;
  klasName?: string | null;
  avatarNummer: number;
}

export interface LeerlingLeerlijnAverageModel {
  leerlingId: string;
  name: string;
  leerlijnAverages: LeerlijnAverageModel[];
  schoolCareerAverage: number;
  leerlingLeerjaar: Leerjaar;
  showLeerlingLeerjaar: boolean;
  readonly schooljaarAverage: number;
  readonly displaySchooljaarAverage: number;
  readonly displaySchoolCareerAverage: number;
}

export interface LeerlingNotitieAddedEvent {
  id: string;
  leerlingId: string;
}

export interface LeerlingOverviewModel {
  id: string;
  studentNumber: string;
  name: string;
  klasName: string;
  leerjaar: Leerjaar;
}

export interface LeerlingParseModel {
  number: StringParsedField;
  firstName: StringParsedField;
  lastName: StringParsedField;
  birthDate: DateTimeNullableParsedField;
  gender: StringParsedField;
  klasName: StringParsedField;
  leerjaren: Int32NullableParsedField;
  status: LeerlingStatus;
  readonly isValid: boolean;
  readonly hasChanged: boolean;
}

export interface LeerlingRapportModel {
  leerlingId: string;
  leerlingNaam: string;
  avatarNummer: number;
  klasNaam: string;
  leerjaar: Leerjaar;
  from: Date;
  to: Date;
  name?: string | null;
  docentNaam: string;
  rapportNotitie?: string | null;
  leerlijnAverages: LeerlijnAverageModel[];
  sociaalEmotioneelThemaDomeinAverages: SociaalEmotioneelThemaDomeinAverageModel[];
  groupedBeweegresultaatSentences: GroupedBeweegresultaatSentenceModel[];
  groupedSociaalEmotioneelResultaatSentences: GroupedSociaalEmotioneelResultaatSentenceModel[];
  topBeweegthemas: TopBeweegthemaModel[];
  sportdeelname: SportdeelnameModel;
  readonly maxScore?: number | null;
}

export interface LeerlingResultaatModel {
  leerlingId: string;
  leerlingNaam: string;
  groep: number;
  leerlingLeerjaar: Leerjaar;
  showLeerlingLeerjaar: boolean;
  klasNaam?: string | null;
  showKlas: boolean;
  beweegresultaten: BeweegresultaatDocentModel[];
  sociaalEmotioneelResultaten: SociaalEmotioneelResultaatDocentModel[];
}

export interface LeerlingSelectionModel {
  id: string;
  name: string;
  leerjaar: Leerjaar;
}

export interface LeerlingSociaalEmotioneelThemaDomeinAverageModel {
  leerlingId: string;
  name: string;
  sociaalEmotioneelThemaDomeinAverages: SociaalEmotioneelThemaDomeinAverageModel[];
  schoolCarreerAverage: number;
  leerlingLeerjaar: Leerjaar;
  showLeerlingLeerjaar: boolean;
  readonly schooljaarAverage: number;
  readonly displaySchooljaarAverage: number;
  readonly displaySchoolCarreerAverage: number;
}

export interface LeerlingSociaalEmotioneelThemaProgressModel {
  leerlingId: string;
  sociaalEmotioneelThemaId: string;
  sociaalEmotioneelThemasReeksId: string;
  domein: SociaalEmotioneelDomein;
  name: string;
  reeksName: string;
  sociaalEmotioneelThemaLeerjaarCombo: LeerjaarCombo;
  leerlingLeerjaar: Leerjaar;
  behaaldNiveau: number;
  maxNiveau: number;
  behaaldAt?: Date | null;
  score: number;
  readonly resultaat: string;
  behaaldeSociaalEmotioneelDoelen: string[];
  readonly isOverachieved: boolean;
  readonly isMaxNiveau: boolean;
}

export interface LeerlingStatistiekenModel {
  schoolCareerAverage: number;
  schooljaarAverage: number;
  totalAanwezig: number;
  totalAfwezig: number;
  totalAnders: number;
  totalGeblesseerd: number;
  totalZiek: number;
  totalTeLaat: number;
  totalGymkledingVergeten: number;
}

export enum LeerlingStatus {
  New = "New",
  Updated = "Updated",
  Schoolverlater = "Schoolverlater",
  Zittenblijver = "Zittenblijver",
  Doorstromer = "Doorstromer",
}

export interface LeerlingTimeoutModel {
  lesId: string;
  datum: Date;
  klasNamen: string;
  type: TimeoutType;
}

export interface LeerlingUpdatedEvent {
  id: string;
}

export interface LesAfgerondEvent {
  schoolId: string;
  lesId: string;
}

export interface LesAfrondenCommand {
  lesId: string;
  timetravel: boolean;
}

export enum LesAfrondenErrors {
  LesNotActief = "LesNotActief",
}

export interface LesAfrondenPrecheckCommand {
  lesId: string;
}

export interface LesAfrondenPrecheckResponse {
  beweegactiviteiten: BeweegactiviteitPrecheckModel[];
  sociaalEmotioneelThemas: SociaalEmotioneelThemaPrecheckModel[];
  readonly hasUnfinishedResultaten: boolean;
}

export interface LesCreatedEvent {
  id: string;
}

export interface LesDeletedEvent {
  schoolId: string;
  ids: string[];
}

export interface LesGeannuleerdEvent {
  lesId: string;
}

export interface LesNotitieModel {
  id: string;
  notitie: string;
  docentNaam: string;
  updatedAt: Date;
}

export interface LesNotitieUpdatedEvent {
  id: string;
}

export interface LesOverviewModel {
  id: string;
  klas: string;
  docent: string;
  beweegactiviteiten: string[];
  sociaalEmotioneelThemas: string[];
  status: LesStatus;
  startedAt: Date;
}

export interface LesStartedEvent {
  lesId: string;
}

export enum LesStatus {
  Concept = "Concept",
  Actief = "Actief",
  Afgerond = "Afgerond",
}

export interface LesUpdatedEvent {
  id: string;
}

export enum Lesaanwezigheid {
  Aanwezig = "Aanwezig",
  Ziek = "Ziek",
  Geblesseerd = "Geblesseerd",
  Anders = "Anders",
  TeLaat = "TeLaat",
}

export interface LesadministratieAanwezigheidUpdatedEvent {
  lesId: string;
  leerlingId: string;
}

export interface LesadministratieCountModel {
  count: number;
  total: number;
}

export interface LesadministratieGymkledingUpdatedEvent {
  lesId: string;
  leerlingId: string;
}

export interface LesadministratieModel {
  lesId: string;
  leerlingId: string;
  leerlingNaam: string;
  leerlingLeerjaar: Leerjaar;
  showLeerlingLeerjaar: boolean;
  klasNaam?: string | null;
  showKlas: boolean;
  aanwezigheid: Lesaanwezigheid;
  gymkleding: boolean;
  timeoutType: TimeoutType;
  opmerking?: string | null;
}

export interface LesadministratieOpmerkingUpdatedEvent {
  lesId: string;
  leerlingId: string;
}

export interface LesadministratieStatistiekenLeerling {
  leerlingId: string;
  naam: string;
  klasNaam: string;
  afwezigheid: number;
  blessures: number;
  gymkleding: number;
  korteTimeout: number;
  langeTimeout: number;
  uitsluitingLes: number;
  timeoutsTotaal: number;
}

export interface LesadministratieTimeoutTypeUpdatedEvent {
  lesId: string;
  leerlingId: string;
}

export interface LesgroepLeerlingLockModel {
  leerlingId: string;
  groep: number;
}

export interface LesgroepLeerlingModel {
  id: string;
  name: string;
  locked: boolean;
  avatarNummer: number;
  score: number;
}

export interface LesgroepModel {
  groep: number;
  leerlingen: LesgroepLeerlingModel[];
}

export interface LesgroepenFilterModel {
  aantalGroepen: number;
  beweegthema?: Beweegthema;
  groepeerType: GroepeerType;
  seed: string;
  lockedLeerlingen?: LesgroepLeerlingLockModel[] | null;
  excludedLeerlingen?: string[] | null;
}

export interface LesgroepenRedistributedEvent {
  lesId: string;
}

export interface LicentieAdminModel {
  id: string;
  licentieType: LicentieType;
  startDate: Date;
  endDate: Date;
  aantalLeerlingen?: number | null;
  actualAantalLeerlingen: number;
  verwerkersovereenkomst: boolean;
}

export interface LicentieCountsAdminModel {
  proefperiode: number;
  abonnement: number;
  showcase: number;
  verlopen: number;
}

export enum LicentieType {
  Proefperiode = "Proefperiode",
  Abonnement = "Abonnement",
  Showcase = "Showcase",
}

export interface Login2FARecoveryRequest {
  email: string;
  temporaryToken: string;
  recoveryCode: string;
}

export enum LoginErrors {
  EmailNotConfirmed = "EmailNotConfirmed",
  InvalidCredentials = "InvalidCredentials",
  UserIsBlocked = "UserIsBlocked",
  TooManyAttempts = "TooManyAttempts",
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  accessToken?: string | null;
  refreshToken?: string | null;
  requiresTwoFactor?: boolean | null;
  temporaryToken?: string | null;
}

export enum LoginWith2FaRecoveryCodeErrors {
  InvalidToken = "InvalidToken",
  TwoFactorRecoveryCodeInvalid = "TwoFactorRecoveryCodeInvalid",
  UserIsBlocked = "UserIsBlocked",
}

export interface MaandCountAdminModel {
  jaar: number;
  maand: number;
  count: number;
}

export enum MailDeliveryStatus {
  Unknown = "Unknown",
  Sent = "Sent",
  Delivered = "Delivered",
  Delayed = "Delayed",
  Bounced = "Bounced",
  Complained = "Complained",
  Failed = "Failed",
  Suppressed = "Suppressed",
}

export enum MarkReadErrors {
  NotAllowedWhileImpersonating = "NotAllowedWhileImpersonating",
}

export interface MrtModel {
  mrtLes: boolean;
  fysiotherapie: boolean;
  tweedeLijn: boolean;
}

export interface NotitieModel {
  id: string;
  lesId?: string | null;
  leerlingId?: string | null;
  notitie: string;
  docentNaam: string;
  context?: string | null;
  notitieType: NotitieType;
  leerlijn?: Leerlijn;
  beweegthema?: Beweegthema;
  domein?: SociaalEmotioneelDomein;
  afgerondAt?: Date | null;
  withinRange: boolean;
}

export enum NotitieType {
  Beweegresultaat = "Beweegresultaat",
  SociaalEmotioneelThemaResultaat = "SociaalEmotioneelThemaResultaat",
  Administratie = "Administratie",
  Rapport = "Rapport",
  Les = "Les",
  Leerling = "Leerling",
}

export interface OpstellingsfotoExportDto {
  id: string;
  fileId: string;
  fileName: string;
  blobName: string;
  contentType: string;
  fileSize: number;
  order: number;
}

export enum ParseLeerlingenErrors {
  InvalidHeaders = "InvalidHeaders",
  EmptyFile = "EmptyFile",
  InvalidFile = "InvalidFile",
}

export interface ParseLeerlingenResponse {
  klassen: KlasParseModel[];
  schoolverlaters: LeerlingParseModel[];
  zittenblijvers: LeerlingParseModel[];
  doorstromers: LeerlingParseModel[];
  newLeerlingen: LeerlingParseModel[];
  editedLeerlingen: LeerlingParseModel[];
}

export enum ParsingValidationErrorCode {
  EmptyField = "EmptyField",
  InvalidDate = "InvalidDate",
  InvalidGender = "InvalidGender",
  InvalidNumber = "InvalidNumber",
  Duplicate = "Duplicate",
}

export interface PasskeyModel {
  name: string;
  credentialId: string;
}

export interface PasskeyVerifyRequest {
  credentials: string;
  name: string;
}

export interface PasswordResetEmailProps {
  firstname: string;
  resetLink: string;
}

export interface PriceResponse {
  price: number;
  discountPrice?: number | null;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export enum ProgressStatus {
  NotStarted = "NotStarted",
  PartiallyComplete = "PartiallyComplete",
  Complete = "Complete",
}

export interface RapportCreatedEvent {
  id: string;
}

export interface RapportDeletedEvent {
  id: string;
}

export enum RapportElementen {
  None = "None",
  IkCirkelBeweegactiviteiten = "IkCirkelBeweegactiviteiten",
  IkCirkelSociaalEmotioneelThemas = "IkCirkelSociaalEmotioneelThemas",
  SportdeelnameVoorkant = "SportdeelnameVoorkant",
  RapportNotitie = "RapportNotitie",
  Beweegresultaten = "Beweegresultaten",
  SociaalEmotioneelThemaResultaten = "SociaalEmotioneelThemaResultaten",
  TopResultaten = "TopResultaten",
  Avatar = "Avatar",
  SportdeelnameAchterkant = "SportdeelnameAchterkant",
  Handout = "Handout",
  ZwemvaardigheidVoorkant = "ZwemvaardigheidVoorkant",
  ZwemvaardigheidAchterkant = "ZwemvaardigheidAchterkant",
  FietsvaardigheidVoorkant = "FietsvaardigheidVoorkant",
  FietsvaardigheidAchterkant = "FietsvaardigheidAchterkant",
}

export interface RapportElementenUpdatedEvent {
  id: string;
}

export interface RapportFilterModel {
  leerlijnFilter: FilterTreeModel;
  sociaalEmotioneelDomeinFilter: FilterTreeModel;
}

export interface RapportFilterSelectionModel {
  leerlijnSelectie: LeerlijnFilterSelectionModel;
  domeinSelectie: DomeinFilterSelectionModel;
}

export interface RapportFilterUpdatedEvent {
  id: string;
}

export interface RapportKlassenUpdatedEvent {
  id: string;
}

export interface RapportNotitieModel {
  rapportId: string;
  leerlingId: string;
  leerlingNaam: string;
  lastName: string;
  notitie?: string | null;
  notitiesInRangeCount: number;
}

export interface RapportNotitieUpdatedEvent {
  id: string;
}

export interface RapportOverviewModel {
  id: string;
  from: Date;
  to: Date;
  docent: string;
  name?: string | null;
  klassen: KlasListModel[];
}

export interface RapportPeriodUpdatedEvent {
  id: string;
}

export enum Recover2FAErrors {
  TwoFactorRecoveryCodeInvalid = "TwoFactorRecoveryCodeInvalid",
}

export interface Recover2FARequest {
  code: string;
}

export enum RefreshTokenErrors {
  InvalidToken = "InvalidToken",
}

export interface RedistributeLesgroepenCommand {
  lesId: string;
}

export interface RefreshTokenRequest {
  accessToken: string;
  refreshToken: string;
}

export enum RegisterErrors {
  RegistrationFailed = "RegistrationFailed",
  EmailInvalid = "EmailInvalid",
}

export interface RegisterRequest {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  inviteType: InviteType;
}

export interface RegisterSchoolCommand {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  brin?: string | null;
}

export enum RegisterSchoolErrors {
  UserAlreadyExists = "UserAlreadyExists",
  RegistrationFailed = "RegistrationFailed",
  EmailInvalid = "EmailInvalid",
  SchoolAlreadyExists = "SchoolAlreadyExists",
}

export interface RemoveDocentCommand {
  schooldocentId: string;
}

export enum RemoveDocentErrors {
  CannotRemoveHoofddocent = "CannotRemoveHoofddocent",
}

export interface RemoveDocentFromSchoolAdminCommand {
  schooldocentId: string;
  schoolId: string;
}

export interface RemoveVerenigingCommand {
  verenigingId: string;
}

export interface RenamePasskeyRequest {
  credentialId: string;
  name: string;
}

export interface ReplayDeadLettersAdminCommand {
  ids: string[];
}

export enum RequestError {
  MissingTenantHeader = "MissingTenantHeader",
  InvalidTenant = "InvalidTenant",
  InvalidRequest = "InvalidRequest",
  TenantAccessDenied = "TenantAccessDenied",
  TenantWriteRequiresMembership = "TenantWriteRequiresMembership",
  InvalidSearchQuery = "InvalidSearchQuery",
}

export enum ResendConfirmationEmailErrors {
  EmailAlreadyConfirmed = "EmailAlreadyConfirmed",
}

export interface ResendConfirmationEmailRequest {
  email: string;
}

export interface ResendSchooldocentInviteAdminCommand {
  schooldocentInviteId: string;
}

export interface ResendSchooldocentInviteCommand {
  schooldocentInviteId: string;
}

export enum ResetPasswordErrors {
  PasswordResetFailed = "PasswordResetFailed",
  UserIsBlocked = "UserIsBlocked",
}

export interface ResetPasswordRequest {
  email: string;
  token: string;
  newPassword: string;
}

export interface ResetUser2FaCommand {
  userId: string;
}

export enum ResultaatType {
  Behaald = "Behaald",
  MaxBehaald = "MaxBehaald",
  Overachieved = "Overachieved",
}

export interface SchoolAdminOverviewModel {
  id: string;
  name: string;
  brin: string;
  bestuursnaam: string;
  bestuursnummer: string;
  plaats: string;
  hoofdDocent?: string | null;
  licentieType: LicentieType;
  endDate: Date;
  createdAt: Date;
  verwerkersovereenkomst: boolean;
}

export interface SchoolDetailAdminModel {
  id: string;
  name: string;
  alias?: string | null;
  slug: string;
  brin: string;
  isOfficialBrin: boolean;
  address: string;
  houseNumber: string;
  postalCode: string;
  city: string;
  phoneNumber: string;
  bestuursnummer: string;
  bestuursnaam: string;
  maxDocenten: number;
  isZuurpruim: boolean;
  excludeFromStatistics: boolean;
  hoofdDocent: string;
  licentie: LicentieAdminModel;
  createdAt: Date;
}

export interface SchoolDetailModel {
  id: string;
  slug: string;
  name: string;
  alias?: string | null;
  brin: string;
  address: string;
  houseNumber: string;
  postalCode: string;
  city: string;
  phoneNumber: string;
  bestuursnummer: string;
  bestuursnaam: string;
  logo?: SchoolLogoModel;
}

export interface SchoolKpiAdminModel {
  docenten: number;
  leerlingen: number;
  klassen: number;
  lessenGegeven: number;
  scoresIngevoerd: number;
  laatsteLesAfgerondAt?: Date | null;
}

export interface SchoolLogoModel {
  originalFileId: string;
  croppedFileId: string;
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface SchoolReadyForUseEmailProps {
  firstName: string;
  schoolName: string;
}

export interface SchoolSearchResponse {
  brin: string;
  schoolName: string;
  address: string;
  houseNumber: string;
  postalCode: string;
  city: string;
  phoneNumber: string;
  bestuursnummer: string;
  bestuursnaam: string;
  isRegistered: boolean;
}

export interface SchoolSelectModel {
  id: string;
  slug: string;
  name: string;
  brin: string;
  licentieType: LicentieType;
}

export interface SchoolSelectedEvent {
  schoolSlug: string;
}

export interface SchoolSubscribeCommand {
  consentText: string;
}

export interface SchoolSubscriptionEmailProps {
  firstName: string;
  schoolNaam: string;
  acceptedAt: Date;
  discountPrice?: number | null;
  price: number;
}

export interface SchoolTrialEmailProps {
  firstName: string;
}

export interface SchoolTrialExpirationReminderEmailProps {
  firstName: string;
  school: string;
  daysLeft: number;
}

export interface SchoolTrialExpiredEmailProps {
  firstName: string;
  schoolName: string;
}

export interface SchoolUnsubscribeCommand {}

export interface SchooldocentInviteOverviewModel {
  id: string;
  inviteeEmail: string;
  expiresAt: Date;
  status: InviteStatus;
  canDelete: boolean;
  mailDelivery?: InviteMailDeliveryModel;
  readonly canResend: boolean;
}

export interface SchooljaarAdminModel {
  id: string;
  fromYear: number;
  toYear: number;
  name: string;
}

export interface SelectSchoolCommand {
  schoolSlug: string;
}

export interface SendPendingInvitesAdminCommand {
  expirationDays: number;
}

export interface SendPendingInvitesAdminResponse {
  dispatched: number;
}

export interface SetHoofdDocentCommand {
  schoolDocentId: string;
}

export interface SetHoofdDocentForSchoolAdminCommand {
  schoolId: string;
  schoolDocentId: string;
}

export interface SetSystemNotificationAdminCommand {
  slug: string;
  endsAt: Date;
}

export interface SociaalEmotioneelDoelDetailModel {
  id?: string | null;
  description: string;
}

export interface SociaalEmotioneelDoelExportDto {
  id: string;
  description: string;
  order: number;
}

export enum SociaalEmotioneelDomein {
  Zelfbewustzijn = "Zelfbewustzijn",
  Zelfsturing = "Zelfsturing",
  Inlevingsvermogen = "Inlevingsvermogen",
  Samenwerken = "Samenwerken",
  MoreelKompas = "MoreelKompas",
  InzetEnGedrag = "InzetEnGedrag",
}

export interface SociaalEmotioneelResultaatDocentModel {
  leerlingId: string;
  sociaalEmotioneelThemaId: string;
  behaaldeSociaalEmotioneelDoelen: string[];
  opmerking?: string | null;
  historie?: SociaalEmotioneelResultaatHistorieModel;
  leerlingLeerjaar: Leerjaar;
  sociaalEmotioneelThemaLeerjaarCombo: LeerjaarCombo;
  readonly isOverachieved: boolean;
}

export interface SociaalEmotioneelResultaatHistorieModel {
  lesId: string;
  leerlingId: string;
  sociaalEmotioneelThemaId: string;
  date: Date;
  behaaldeSociaalEmotioneelDoelen: string[];
  readonly timeSince: string;
  sociaalEmotioneelThemaLeerjaarCombo: LeerjaarCombo;
  leerlingLeerjaar: Leerjaar;
  readonly isOverachieved: boolean;
}

export interface SociaalEmotioneelResultaatModel {
  lesId: string;
  leerlingId: string;
  sociaalEmotioneelThemaId: string;
  behaaldeSociaalEmotioneelDoelen: string[];
  previousBehaaldeSociaalEmotioneelDoelen?: string[] | null;
}

export interface SociaalEmotioneelResultaatOpmerkingUpdatedEvent {
  lesId: string;
  leerlingId: string;
  sociaalEmotioneelThemaId: string;
}

export interface SociaalEmotioneelResultaatSentenceModel {
  sociaalEmotioneelThemaId: string;
  sentence: string;
  resultaatType: ResultaatType;
}

export interface SociaalEmotioneelResultaatUpdatedEvent {
  schoolId: string;
  lesId: string;
  leerlingId: string;
}

export interface SociaalEmotioneelThemaDetailModel {
  id?: string | null;
  name: string;
  domein?: SociaalEmotioneelDomein;
  leerjaarCombo: LeerjaarCombo;
  sociaalEmotioneelZinType: SociaalEmotioneelZinType;
  isMeerkeuze: boolean;
  sociaalEmotioneelDoelen: SociaalEmotioneelDoelDetailModel[];
  toelichting?: string | null;
}

export interface SociaalEmotioneelThemaDomeinAverageModel {
  domein: SociaalEmotioneelDomein;
  average: number;
  containsOverachieved: boolean;
  readonly displayAverage: number;
}

export interface SociaalEmotioneelThemaExportDto {
  id: string;
  name: string;
  leerjaarCombo: LeerjaarCombo;
  toelichting?: string | null;
  versie: SociaalEmotioneelThemaversieExportDto;
}

export interface SociaalEmotioneelThemaPrecheckModel {
  sociaalEmotioneelThemaId: string;
  name: string;
  leerjaarCombo: LeerjaarCombo;
  leerlingenWithoutResultaat: string[];
}

export interface SociaalEmotioneelThemaSelectieModel {
  id: string;
  leerjaarCombo: LeerjaarCombo;
  name: string;
}

export interface SociaalEmotioneelThemaToRemoveModel {
  sociaalEmotioneelThemaId: string;
  name: string;
  leerjaarCombo: LeerjaarCombo;
  leerlingen: string[];
}

export interface SociaalEmotioneelThemasReeksAdminOverviewModel {
  schoolName: string;
  id: string;
  name: string;
  domein: SociaalEmotioneelDomein;
  isDefault: boolean;
  isPublished: boolean;
  leerjaarCombo: LeerjaarCombo[];
  canTogglePublished: boolean;
}

export interface SociaalEmotioneelThemasReeksCreatedEvent {
  schoolId: string;
  id: string;
}

export interface SociaalEmotioneelThemasReeksDeletedEvent {
  schoolId: string;
  deletedIds: string[];
}

export interface SociaalEmotioneelThemasReeksDetailModel {
  id?: string | null;
  name: string;
  domein: SociaalEmotioneelDomein;
  isDefault?: boolean | null;
  isPublished?: boolean | null;
  canTogglePublished: boolean;
  sociaalEmotioneelThemaEenTwee?: SociaalEmotioneelThemaDetailModel;
  sociaalEmotioneelThemaDrieVier?: SociaalEmotioneelThemaDetailModel;
  sociaalEmotioneelThemaVijfZes?: SociaalEmotioneelThemaDetailModel;
  sociaalEmotioneelThemaZevenAcht?: SociaalEmotioneelThemaDetailModel;
}

export interface SociaalEmotioneelThemasReeksExportDto {
  id: string;
  name: string;
  domein: SociaalEmotioneelDomein;
  isDefault: boolean;
  isPublished: boolean;
  sociaalEmotioneelThemas: SociaalEmotioneelThemaExportDto[];
}

export interface SociaalEmotioneelThemasReeksOverviewModel {
  id: string;
  name: string;
  domein: SociaalEmotioneelDomein;
  isDefault: boolean;
  isPublished: boolean;
  leerjaarCombo: LeerjaarCombo[];
  canTogglePublished: boolean;
}

export interface SociaalEmotioneelThemasReeksSelectieModel {
  id: string;
  reeksName: string;
  isDefault: boolean;
  sociaalEmotioneelThemas: SociaalEmotioneelThemasSelectieModel;
}

export interface SociaalEmotioneelThemasReeksUpdatedEvent {
  schoolId: string;
  id: string;
}

export interface SociaalEmotioneelThemasSelectieModel {
  sociaalEmotioneelThemaEenTwee?: SociaalEmotioneelThemaSelectieModel;
  sociaalEmotioneelThemaDrieVier?: SociaalEmotioneelThemaSelectieModel;
  sociaalEmotioneelThemaVijfZes?: SociaalEmotioneelThemaSelectieModel;
  sociaalEmotioneelThemaZevenAcht?: SociaalEmotioneelThemaSelectieModel;
}

export interface SociaalEmotioneelThemaversieExportDto {
  id: string;
  version: number;
  sociaalEmotioneelZinType: SociaalEmotioneelZinType;
  isMeerkeuze: boolean;
  sociaalEmotioneelDoelen: SociaalEmotioneelDoelExportDto[];
}

export enum SociaalEmotioneelZinType {
  IkVind = "IkVind",
  IkKan = "IkKan",
}

export interface SportExportDto {
  id: string;
  name: string;
}

export interface SportModel {
  id: string;
  name: string;
  verenigingen?: VerenigingModel[] | null;
}

export interface SportSelectModel {
  id: string;
  name: string;
  selected: boolean;
}

export interface SportdeelnameChartData {
  name: string;
  count: number;
}

export interface SportdeelnameCountModel {
  count: number;
  total: number;
}

export enum SportdeelnameError {
  SportNotFound = "SportNotFound",
  VerenigingNotFound = "VerenigingNotFound",
  SportAlreadyExists = "SportAlreadyExists",
  SportdeelnameNotFound = "SportdeelnameNotFound",
}

export interface SportdeelnameModel {
  id: string;
  leerlingId: string;
  leerlingNaam: string;
  zwemvaardigheid: ZwemvaardigheidModel;
  fietsvaardigheid: FietsvaardigheidModel;
  mrt: MrtModel;
  hasNoSport?: boolean | null;
  sporten: SportSelectModel[];
  wensSporten: SportSelectModel[];
  verenigingen: VerenigingSelectModel[];
  leerlingLeerjaar?: number | null;
  klasNaam?: string | null;
}

export interface SportdeelnameStatistiekenLeerling {
  leerlingId: string;
  naam: string;
  klasNaam: string;
  hasNoSport: boolean;
  sporten: string[];
  verenigingen: string[];
  wensSporten: string[];
  mrt?: boolean | null;
  zwemvaardigheid: string[];
  fietsvaardigheid: string[];
}

export interface SportdeelnameTrendPunt {
  schooljaar: string;
  fromYear: number;
  peildatum: Date;
  total: number;
  metSport: number;
  metZwemdiploma: number;
  kanFietsen: number;
}

export interface StartImpersonationRequest {
  targetUserId: string;
}

export interface StartImpersonationResponse {
  impersonationToken: string;
}

export interface StartLesCommand {
  lesId: string;
  timetravel: boolean;
}

export enum StartLesErrors {
  LesNotInConcept = "LesNotInConcept",
}

export enum StartLesErrors {
  DocentAlreadyHasActiveLes = "DocentAlreadyHasActiveLes",
}

export interface StatistiekKolom {
  combo: LeerjaarCombo;
  beweegthemas: BeweegthemaChartData[];
}

export enum StatistiekTrend {
  None = "None",
  Up = "Up",
  Down = "Down",
  Equal = "Equal",
}

export interface StringParsedField {
  value?: string | null;
  oldValue?: string | null;
  validationStatus: FieldValidationType;
  validationCode?: ParsingValidationErrorCode;
  readonly isValid: boolean;
  readonly hasChanged: boolean;
}

export interface SystemNotificationModel {
  id: string;
  slug: string;
  endsAt: Date;
}

export interface TicketAdminDetailModel {
  id: string;
  ticketNumber: number;
  subject: string;
  type: TicketType;
  status: TicketStatus;
  createdByName: string;
  createdByEmail: string;
  createdAt: Date;
  closedAt?: Date | null;
  assignedAdminUserId?: string | null;
  assignedAdminName?: string | null;
  messages: TicketMessageModel[];
}

export interface TicketAdminOverviewModel {
  id: string;
  ticketNumber: number;
  subject: string;
  type: TicketType;
  status: TicketStatus;
  createdByName: string;
  createdByEmail: string;
  createdAt: Date;
  lastActivityAt: Date;
  hasUnread: boolean;
  awaitingAdminReply: boolean;
  assignedAdminUserId?: string | null;
  assignedAdminName?: string | null;
  isAssignedToMe: boolean;
}

export interface TicketAssigneeModel {
  userId: string;
  name: string;
}

export interface TicketAttachmentModel {
  fileId: string;
  fileName: string;
}

export interface TicketDetailModel {
  id: string;
  ticketNumber: number;
  subject: string;
  type: TicketType;
  status: TicketStatus;
  createdAt: Date;
  messages: TicketMessageModel[];
}

export enum TicketMessageAuthorRole {
  User = "User",
  Admin = "Admin",
}

export interface TicketMessageModel {
  id: string;
  authorName: string;
  authorRole: TicketMessageAuthorRole;
  content: string;
  createdAt: Date;
  editedAt?: Date | null;
  editable: boolean;
  deletable: boolean;
  attachments: TicketAttachmentModel[];
}

export interface TicketNotificationEmailProps {
  recipientName: string;
  ticketNumber: number;
  subject: string;
  ticketUrl: string;
  messages: TicketNotificationMessageProps[];
}

export interface TicketNotificationMessageProps {
  authorName: string;
  sentAt: string;
  html: string;
}

export interface TicketOverviewModel {
  id: string;
  ticketNumber: number;
  subject: string;
  type: TicketType;
  status: TicketStatus;
  lastActivityAt: Date;
  hasUnread: boolean;
}

export interface TicketStatsAdminModel {
  open: number;
  wachtOpReactie: number;
  mediaanEersteReactieUren?: number | null;
}

export enum TicketStatus {
  Open = "Open",
  Closed = "Closed",
}

export enum TicketType {
  Question = "Question",
  Suggestion = "Suggestion",
}

export enum TimeoutType {
  Geen = "Geen",
  KorteTimeout = "KorteTimeout",
  LangeTimeout = "LangeTimeout",
  UitsluitingLes = "UitsluitingLes",
}

export interface ToggleLesAvatarsCommand {
  lesId: string;
}

export interface TopBeweegthemaModel {
  leerlijn: Leerlijn;
  beweegthema: Beweegthema;
}

export interface TwoFactorSetupResponse {
  sharedKey: string;
  qrCodeUri: string;
  recoveryCodes: string[];
}

export enum UpdateAliasErrors {
  UserIsNotHoofddocent = "UserIsNotHoofddocent",
}

export interface UpdateBeweegactiviteitenreeksAdminCommand {
  beweegactiviteitenreeks: BeweegactiviteitenreeksDetailModel;
}

export interface UpdateBeweegactiviteitenreeksCommand {
  beweegactiviteitenreeks: BeweegactiviteitenreeksDetailModel;
}

export enum UpdateBeweegactiviteitenreeksErrors {
  InvalidBeoordelingsschaal = "InvalidBeoordelingsschaal",
  BeweegdoelRequired = "BeweegdoelRequired",
  UpdateNotAllowed = "UpdateNotAllowed",
}

export interface UpdateBeweegactiviteitenreeksPublicatieAdminCommand {
  beweegactiviteitenreeksId: string;
  published: boolean;
}

export interface UpdateBeweegactiviteitenreeksPublicatieCommand {
  beweegactiviteitenreeksId: string;
  published: boolean;
}

export interface UpdateBeweegresultaatCommand {
  lesId: string;
  leerlingId: string;
  beweegactiviteitId: string;
  niveau?: number | null;
  waarde?: number | null;
  beweegdoelIds?: string[] | null;
}

export interface UpdateBeweegresultaatOpmerkingCommand {
  lesId: string;
  leerlingId: string;
  beweegactiviteitId: string;
  opmerking?: string | null;
}

export enum UpdateBrinErrors {
  SchoolAlreadyExists = "SchoolAlreadyExists",
}

export interface UpdateDocentAliasCommand {
  alias?: string | null;
}

export interface UpdateFietsvaardigheidCommand {
  fietsvaardigheid: FietsvaardigheidModel;
}

export interface UpdateHasNoSportCommand {
  leerlingId: string;
  hasNoSport: boolean;
}

export interface UpdateKlasCommand {
  klasId: string;
  name: string;
  leerjaren: Leerjaar[];
}

export enum UpdateKlasErrors {
  KlasAlreadyExists = "KlasAlreadyExists",
}

export interface UpdateLastSeenSystemNotificationCommand {
  systemNotificationId: string;
}

export interface UpdateLeerlingAvatarHandlerCommand {
  leerlingId: string;
  avatarNummer: number;
}

export interface UpdateLeerlingCommand {
  leerlingId: string;
  studentNumber: string;
  firstName: string;
  lastName: string;
  birthDate: Date;
  gender: Gender;
  klasId: string;
  leerjaar: Leerjaar;
}

export enum UpdateLeerlingErrors {
  LeerlingAlreadyExists = "LeerlingAlreadyExists",
}

export interface UpdateLesCommand {
  lesId: string;
  beweegactiviteiten: string[];
  sociaalEmotioneelThemas: string[];
  filter: LesgroepenFilterModel;
  date: Date;
}

export enum UpdateLesErrors {
  NoLeerlingenFoundForLes = "NoLeerlingenFoundForLes",
  LesNotActief = "LesNotActief",
}

export interface UpdateLesNotitieCommand {
  lesId: string;
  notitie?: string | null;
}

export interface UpdateLesPrecheckCommand {
  lesId: string;
  beweegactiviteiten: string[];
  sociaalEmotioneelThemas: string[];
  filter: LesgroepenFilterModel;
}

export interface UpdateLesPrecheckResponse {
  beweegactiviteitenToRemove: BeweegactiviteitToRemoveModel[];
  sociaalEmotioneelThemasToRemove: SociaalEmotioneelThemaToRemoveModel[];
}

export interface UpdateLesadministratieAanwezigheidCommand {
  lesId: string;
  leerlingId: string;
  aanwezigheid: Lesaanwezigheid;
}

export interface UpdateLesadministratieGymkledingCommand {
  lesId: string;
  leerlingId: string;
  gymkleding: boolean;
}

export interface UpdateLesadministratieOpmerkingCommand {
  lesId: string;
  leerlingId: string;
  opmerking?: string | null;
}

export interface UpdateLesadministratieTimeoutTypeCommand {
  lesId: string;
  leerlingId: string;
  timeoutType: TimeoutType;
}

export interface UpdateLicentieAantalLeerlingenAdminCommand {
  schoolId: string;
  aantalLeerlingen?: number | null;
}

export interface UpdateLicentieEndDateAdminCommand {
  schoolId: string;
  endDate: Date;
}

export interface UpdateLicentieTypeAdminCommand {
  schoolId: string;
  licentieType: LicentieType;
}

export interface UpdateLicentieVerwerkersovereenkomstAdminCommand {
  schoolId: string;
  verwerkersovereenkomst: boolean;
}

export interface UpdateLogoCommand {
  originalFileId: string;
  croppedFileId: string;
  x: number;
  y: number;
  width: number;
  height: number;
}

export enum UpdateLogoErrors {
  UserIsNotHoofddocent = "UserIsNotHoofddocent",
}

export interface UpdateMaxDocentenAdminCommand {
  schoolId: string;
  maxDocenten: number;
}

export interface UpdateMrtCommand {
  mrt: MrtModel;
}

export interface UpdateRapportElementenCommand {
  rapportId: string;
  rapportElementen: RapportElementen[];
}

export interface UpdateRapportFilterCommand {
  rapportId: string;
  filterSelection: RapportFilterSelectionModel;
}

export interface UpdateRapportKlassenCommand {
  rapportId: string;
  klassen: string[];
}

export interface UpdateRapportNotitieCommand {
  rapportId: string;
  leerlingId: string;
  notitie?: string | null;
}

export interface UpdateRapportPeriodCommand {
  rapportId: string;
  from: Date;
  to: Date;
  name?: string | null;
}

export interface UpdateSchoolAliasAdminCommand {
  schoolId: string;
  alias?: string | null;
}

export interface UpdateSchoolAliasCommand {
  alias?: string | null;
}

export interface UpdateSchoolBestuurAdminCommand {
  schoolId: string;
  bestuursnummer?: string | null;
  bestuursnaam?: string | null;
}

export interface UpdateSchoolBrinAdminCommand {
  schoolId: string;
  brin: string;
}

export interface UpdateSchoolContactgegevensAdminCommand {
  schoolId: string;
  address: string;
  houseNumber: string;
  postalCode: string;
  city: string;
  phoneNumber: string;
}

export interface UpdateSchoolExcludeFromStatisticsAdminCommand {
  schoolId: string;
  excludeFromStatistics: boolean;
}

export interface UpdateSchoolIsZuurpruimAdminCommand {
  schoolId: string;
  isZuurpruim: boolean;
}

export interface UpdateSchoolNaamAdminCommand {
  schoolId: string;
  name: string;
}

export interface UpdateSociaalEmotioneelResultaatCommand {
  lesId: string;
  leerlingId: string;
  sociaalEmotioneelThemaId: string;
  sociaalEmotioneelDoelIds: string[];
}

export interface UpdateSociaalEmotioneelResultaatOpmerkingCommand {
  lesId: string;
  leerlingId: string;
  sociaalEmotioneelThemaId: string;
  opmerking?: string | null;
}

export interface UpdateSociaalEmotioneelThemasReeksAdminCommand {
  sociaalEmotioneelThemasReeks: SociaalEmotioneelThemasReeksDetailModel;
}

export interface UpdateSociaalEmotioneelThemasReeksCommand {
  sociaalEmotioneelThemasReeks: SociaalEmotioneelThemasReeksDetailModel;
}

export enum UpdateSociaalEmotioneelThemasReeksErrors {
  MinimumThreeSociaalEmotioneelDoelenRequired = "MinimumThreeSociaalEmotioneelDoelenRequired",
  UpdateNotAllowed = "UpdateNotAllowed",
  MaximumFiveSociaalEmotioneelDoelenAllowed = "MaximumFiveSociaalEmotioneelDoelenAllowed",
}

export interface UpdateSociaalEmotioneelThemasReeksPublicatieAdminCommand {
  sociaalEmotioneelThemasReeksId: string;
  published: boolean;
}

export interface UpdateSociaalEmotioneelThemasReeksPublicatieCommand {
  sociaalEmotioneelThemasReeksId: string;
  published: boolean;
}

export enum UpdateSportdeelnameErrors {
  SportAlreadyExists = "SportAlreadyExists",
}

export interface UpdateSportdeelnameSportCommand {
  sportId: string;
  value: boolean;
}

export interface UpdateSportdeelnameVerenigingCommand {
  verenigingId: string;
  value: boolean;
}

export interface UpdateSportdeelnameWensSportCommand {
  sportId: string;
  value: boolean;
}

export enum UpdateSportdeelnameWensSportErrors {
  SportAlreadyExists = "SportAlreadyExists",
}

export interface UpdateUserEmailRequest {
  email: string;
}

export enum UpdateUserInfoErrors {
  PasswordInvalid = "PasswordInvalid",
}

export interface UpdateUserInfoRequest {
  firstName: string;
  lastName: string;
}

export interface UpdateUserPasswordRequest {
  oldPassword: string;
  newPassword: string;
}

export interface UpdateUserPreferencesCommand {
  defaultAantalGroepen?: number | null;
  defaultAvatarsEnabled?: boolean | null;
}

export interface UpdateZwemvaardigheidCommand {
  zwemvaardigheid: ZwemvaardigheidModel;
}

export interface UploadFileAdminResponse {
  file: FileModel;
}

export enum UploadFileErrors {
  FileTooLarge = "FileTooLarge",
  FileCannotBeEmpty = "FileCannotBeEmpty",
  InvalidFileType = "InvalidFileType",
  UploadFailed = "UploadFailed",
}

export interface UploadFileResponse {
  file: FileModel;
}

export interface UploadTicketFileResponse {
  file: FileModel;
}

export interface UserConfirmationEmailProps {
  confirmationLink: string;
}

export interface UserExistsResponse {
  exists: boolean;
}

export interface UserInfoResponse {
  email: string;
  firstName: string;
  lastName: string;
  twoFactorEnabled: boolean;
  defaultAantalGroepen?: number | null;
  alias?: string | null;
  defaultAvatarsEnabled: boolean;
}

export interface UserRemovedEmailProps {
  firstname: string;
}

export enum ValidateInviteErrors {
  InviteInvalid = "InviteInvalid",
  InviteExpired = "InviteExpired",
  InviteAlreadyAccepted = "InviteAlreadyAccepted",
  NotAuthorized = "NotAuthorized",
}

export interface ValidateInviteResponse {
  inviteId: string;
  inviteType: InviteType;
  inviteeEmail: string;
  schoolName: string;
  userExists: boolean;
}

export interface ValidatePasswordRequest {
  password: string;
}

export interface ValidatePasswordResponse {
  valid: boolean;
  errors: string[];
}

export enum ValidationError {
  Required = "Required",
  MaxLength = "MaxLength",
  MinLength = "MinLength",
  Format = "Format",
  Range = "Range",
  Invalid = "Invalid",
}

export interface ValidationProblemDetails {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  errors: { [key: string]: string[] };

  [key: string]: any;
}

export interface VerenigingModel {
  id: string;
  name: string;
  sportId: string;
}

export interface VerenigingSelectModel {
  id: string;
  name: string;
  selected: boolean;
}

export enum Verify2FALoginErrors {
  InvalidToken = "InvalidToken",
  TwoFactorCodeInvalid = "TwoFactorCodeInvalid",
  UserIsBlocked = "UserIsBlocked",
}

export interface Verify2FALoginRequest {
  email: string;
  temporaryToken: string;
  twoFactorCode: string;
}

export enum Verify2FASetupErrors {
  TwoFactorCodeInvalid = "TwoFactorCodeInvalid",
  TwoFactorAlreadyEnabled = "TwoFactorAlreadyEnabled",
}

export interface Verify2FASetupRequest {
  code: string;
}

export enum VerifyPasskeyLoginErrors {
  PasskeyInvalid = "PasskeyInvalid",
  UserIsBlocked = "UserIsBlocked",
}

export interface VerifyPasskeyLoginRequest {
  credentials: string;
}

export enum VerifyPasskeySetupErrors {
  PasskeyVerificationFailed = "PasskeyVerificationFailed",
  TwoFactorNotEnabled = "TwoFactorNotEnabled",
}

export interface VrijBeweegdoelDetailModel {
  id?: string | null;
  prefix?: string | null;
  postfix?: string | null;
  beoordelingsschalen: BeoordelingsschaalDetailModel[];
  instructiefotos?: FileModel[] | null;
}

export interface VrijBeweegdoelExportDto {
  id: string;
  prefix: string;
  postfix: string;
  beoordelingsschalen: BeoordelingsschaalExportDto[];
  instructiefotos?: InstructiefotoExportDto[] | null;
}

export interface VrijBeweegdoelLesModel {
  id?: string | null;
  prefix?: string | null;
  postfix?: string | null;
  readonly doel: string;
  beoordelingsschalen?: BeoordelingsschaalLesModel[] | null;
}

export interface WeekCountAdminModel {
  weekStart: Date;
  count: number;
}

export interface WeekResultatenAdminModel {
  weekStart: Date;
  doorLeerling: number;
  doorDocent: number;
  sociaalEmotioneel: number;
}

export interface ZwemvaardigheidModel {
  geenDiploma: boolean;
  diplomaA: boolean;
  diplomaB: boolean;
  diplomaC: boolean;
  inProgress: boolean;
  wachtlijst: boolean;
}

export interface Anonymous {
  type?: string | null;
  title?: Title;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous2 {
  type?: string | null;
  title?: Title2;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous3 {
  type?: string | null;
  title?: Title3;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous4 {
  type?: string | null;
  title?: Title4;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous5 {
  type?: string | null;
  title?: Title5;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous6 {
  type?: string | null;
  title?: Title6;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous7 {
  type?: string | null;
  title?: Title7;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous8 {
  type?: string | null;
  title?: Title8;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous9 {
  type?: string | null;
  title?: Title9;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous10 {
  type?: string | null;
  title?: Title10;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous11 {
  type?: string | null;
  title?: Title11;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous12 {
  type?: string | null;
  title?: Title12;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous13 {
  type?: string | null;
  title?: Title13;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous14 {
  type?: string | null;
  title?: Title14;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous15 {
  type?: string | null;
  title?: Title15;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous16 {
  type?: string | null;
  title?: Title16;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous17 {
  type?: string | null;
  title?: Title17;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous18 {
  type?: string | null;
  title?: Title18;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous19 {
  type?: string | null;
  title?: Title19;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous20 {
  type?: string | null;
  title?: Title20;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous21 {
  type?: string | null;
  title?: Title21;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous22 {
  type?: string | null;
  title?: Title22;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous23 {
  type?: string | null;
  title?: Title23;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous24 {
  type?: string | null;
  title?: Title24;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous25 {
  type?: string | null;
  title?: Title25;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous26 {
  type?: string | null;
  title?: Title26;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous27 {
  type?: string | null;
  title?: Title27;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous28 {
  type?: string | null;
  title?: Title28;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous29 {
  type?: string | null;
  title?: Title29;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous30 {
  type?: string | null;
  title?: Title30;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous31 {
  type?: string | null;
  title?: Title31;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous32 {
  type?: string | null;
  title?: Title32;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous33 {
  type?: string | null;
  title?: Title33;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous34 {
  type?: string | null;
  title?: Title34;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous35 {
  type?: string | null;
  title?: Title35;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous36 {
  type?: string | null;
  title?: Title36;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous37 {
  type?: string | null;
  title?: Title37;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous38 {
  type?: string | null;
  title?: Title38;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous39 {
  type?: string | null;
  title?: Title39;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous40 {
  type?: string | null;
  title?: Title40;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous41 {
  type?: string | null;
  title?: Title41;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous42 {
  type?: string | null;
  title?: Title42;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous43 {
  type?: string | null;
  title?: Title43;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous44 {
  type?: string | null;
  title?: Title44;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous45 {
  type?: string | null;
  title?: Title45;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous46 {
  type?: string | null;
  title?: Title46;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous47 {
  type?: string | null;
  title?: Title47;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous48 {
  type?: string | null;
  title?: Title48;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous49 {
  Balanceren?: Beweegthema[];
  Klimmen?: Beweegthema[];
  Zwaaien?: Beweegthema[];
  OverDeKopGaan?: Beweegthema[];
  Springen?: Beweegthema[];
  Hardlopen?: Beweegthema[];
  Mikken?: Beweegthema[];
  Jongleren?: Beweegthema[];
  Doelspelen?: Beweegthema[];
  Tikspelen?: Beweegthema[];
  Stoeispelen?: Beweegthema[];
  BewegenOpMuziek?: Beweegthema[];
}

export interface Anonymous50 {
  type?: string | null;
  title?: Title49;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous51 {
  type?: string | null;
  title?: Title50;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous52 {
  type?: string | null;
  title?: Title51;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous53 {
  type?: string | null;
  title?: Title52;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous54 {
  type?: string | null;
  title?: Title53;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous55 {
  type?: string | null;
  title?: Title54;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous56 {
  type?: string | null;
  title?: Title55;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous57 {
  type?: string | null;
  title?: Title56;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous58 {
  type?: string | null;
  title?: Title57;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous59 {
  type?: string | null;
  title?: Title58;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous60 {
  type?: string | null;
  title?: Title59;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous61 {
  type?: string | null;
  title?: Title60;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous62 {
  type?: string | null;
  title?: Title61;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous63 {
  type?: string | null;
  title?: Title62;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export interface Anonymous64 {
  type?: string | null;
  title?: Title63;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;

  [key: string]: any;
}

export enum Title {
  TooManyAttachments = "TooManyAttachments",
}

export enum Title2 {
  AssigneeNotAdmin = "AssigneeNotAdmin",
}

export enum Title3 {
  FileTooLarge = "FileTooLarge",
  FileCannotBeEmpty = "FileCannotBeEmpty",
  InvalidFileType = "InvalidFileType",
  UploadFailed = "UploadFailed",
}

export enum Title4 {
  SchoolAlreadyExists = "SchoolAlreadyExists",
}

export enum Title5 {
  SchoolAlreadyExists = "SchoolAlreadyExists",
}

export enum Title6 {
  InviteAlreadyExists = "InviteAlreadyExists",
  InviteeIsAdmin = "InviteeIsAdmin",
  MaxDocentenReached = "MaxDocentenReached",
}

export enum Title7 {
  FileTooLarge = "FileTooLarge",
  FileCannotBeEmpty = "FileCannotBeEmpty",
  InvalidFileType = "InvalidFileType",
  UploadFailed = "UploadFailed",
}

export enum Title8 {
  InvalidBeoordelingsschaal = "InvalidBeoordelingsschaal",
  BeweegdoelRequired = "BeweegdoelRequired",
}

export enum Title9 {
  InvalidBeoordelingsschaal = "InvalidBeoordelingsschaal",
  BeweegdoelRequired = "BeweegdoelRequired",
  UpdateNotAllowed = "UpdateNotAllowed",
}

export enum Title10 {
  MinimumThreeSociaalEmotioneelDoelenRequired = "MinimumThreeSociaalEmotioneelDoelenRequired",
  MaximumFiveSociaalEmotioneelDoelenAllowed = "MaximumFiveSociaalEmotioneelDoelenAllowed",
}

export enum Title11 {
  MinimumThreeSociaalEmotioneelDoelenRequired = "MinimumThreeSociaalEmotioneelDoelenRequired",
  UpdateNotAllowed = "UpdateNotAllowed",
  MaximumFiveSociaalEmotioneelDoelenAllowed = "MaximumFiveSociaalEmotioneelDoelenAllowed",
}

export enum Title12 {
  RegistrationFailed = "RegistrationFailed",
  EmailInvalid = "EmailInvalid",
}

export enum Title13 {
  EmailNotConfirmed = "EmailNotConfirmed",
  InvalidCredentials = "InvalidCredentials",
  UserIsBlocked = "UserIsBlocked",
  TooManyAttempts = "TooManyAttempts",
}

export enum Title14 {
  InvalidToken = "InvalidToken",
}

export enum Title15 {
  EmailConfirmationFailed = "EmailConfirmationFailed",
  EmailAlreadyConfirmed = "EmailAlreadyConfirmed",
}

export enum Title16 {
  EmailConfirmationFailed = "EmailConfirmationFailed",
}

export enum Title17 {
  EmailAlreadyConfirmed = "EmailAlreadyConfirmed",
}

export enum Title18 {
  PasswordResetFailed = "PasswordResetFailed",
  UserIsBlocked = "UserIsBlocked",
}

export enum Title19 {
  UserAlreadyExists = "UserAlreadyExists",
  EmailInvalid = "EmailInvalid",
}

export enum Title20 {
  PasswordInvalid = "PasswordInvalid",
}

export enum Title21 {
  TwoFactorAlreadyEnabled = "TwoFactorAlreadyEnabled",
}

export enum Title22 {
  TwoFactorCodeInvalid = "TwoFactorCodeInvalid",
  TwoFactorAlreadyEnabled = "TwoFactorAlreadyEnabled",
}

export enum Title23 {
  InvalidToken = "InvalidToken",
  TwoFactorCodeInvalid = "TwoFactorCodeInvalid",
  UserIsBlocked = "UserIsBlocked",
}

export enum Title24 {
  InvalidToken = "InvalidToken",
  TwoFactorRecoveryCodeInvalid = "TwoFactorRecoveryCodeInvalid",
  UserIsBlocked = "UserIsBlocked",
}

export enum Title25 {
  InvalidCredentials = "InvalidCredentials",
}

export enum Title26 {
  TwoFactorRecoveryCodeInvalid = "TwoFactorRecoveryCodeInvalid",
}

export enum Title27 {
  TwoFactorNotEnabled = "TwoFactorNotEnabled",
}

export enum Title28 {
  PasskeyVerificationFailed = "PasskeyVerificationFailed",
  TwoFactorNotEnabled = "TwoFactorNotEnabled",
}

export enum Title29 {
  PasskeyInvalid = "PasskeyInvalid",
  UserIsBlocked = "UserIsBlocked",
}

export enum Title30 {
  InviteInvalid = "InviteInvalid",
  InviteExpired = "InviteExpired",
  InviteAlreadyAccepted = "InviteAlreadyAccepted",
  NotAuthorized = "NotAuthorized",
}

export enum Title31 {
  InvalidBeoordelingsschaal = "InvalidBeoordelingsschaal",
  BeweegdoelRequired = "BeweegdoelRequired",
}

export enum Title32 {
  InvalidBeoordelingsschaal = "InvalidBeoordelingsschaal",
  BeweegdoelRequired = "BeweegdoelRequired",
  UpdateNotAllowed = "UpdateNotAllowed",
}

export enum Title33 {
  CannotRemoveHoofddocent = "CannotRemoveHoofddocent",
}

export enum Title34 {
  FileTooLarge = "FileTooLarge",
  FileCannotBeEmpty = "FileCannotBeEmpty",
  InvalidFileType = "InvalidFileType",
  UploadFailed = "UploadFailed",
}

export enum Title35 {
  InvalidHeaders = "InvalidHeaders",
  EmptyFile = "EmptyFile",
  InvalidFile = "InvalidFile",
}

export enum Title36 {
  KlasAlreadyExists = "KlasAlreadyExists",
  HasActiveInschrijvingen = "HasActiveInschrijvingen",
  LeerlingAlreadyExists = "LeerlingAlreadyExists",
  VerwerkersovereenkomstRequired = "VerwerkersovereenkomstRequired",
}

export enum Title37 {
  KlasAlreadyExists = "KlasAlreadyExists",
}

export enum Title38 {
  KlasAlreadyExists = "KlasAlreadyExists",
}

export enum Title39 {
  HasActiveInschrijvingen = "HasActiveInschrijvingen",
}

export enum Title40 {
  LeerlingAlreadyExists = "LeerlingAlreadyExists",
}

export enum Title41 {
  LeerlingAlreadyExists = "LeerlingAlreadyExists",
}

export enum Title42 {
  SportAlreadyExists = "SportAlreadyExists",
}

export enum Title43 {
  SportAlreadyExists = "SportAlreadyExists",
}

export enum Title44 {
  NoLeerlingenFoundForLes = "NoLeerlingenFoundForLes",
}

export enum Title45 {
  DocentAlreadyHasActiveLes = "DocentAlreadyHasActiveLes",
}

export enum Title46 {
  NoLeerlingenFoundForLes = "NoLeerlingenFoundForLes",
  LesNotActief = "LesNotActief",
}

export enum Title47 {
  LesNotActief = "LesNotActief",
}

export enum Title48 {
  LesNotActief = "LesNotActief",
}

export enum Title49 {
  SchoolAlreadyExists = "SchoolAlreadyExists",
}

export enum Title50 {
  UserAlreadyExists = "UserAlreadyExists",
  RegistrationFailed = "RegistrationFailed",
  EmailInvalid = "EmailInvalid",
  SchoolAlreadyExists = "SchoolAlreadyExists",
}

export enum Title51 {
  SchoolAlreadyExists = "SchoolAlreadyExists",
}

export enum Title52 {
  UserIsNotHoofddocent = "UserIsNotHoofddocent",
}

export enum Title53 {
  UserIsNotHoofddocent = "UserIsNotHoofddocent",
}

export enum Title54 {
  InviteAlreadyExists = "InviteAlreadyExists",
  InviteeIsAdmin = "InviteeIsAdmin",
  DocentAlreadyExists = "DocentAlreadyExists",
  MaxDocentenReached = "MaxDocentenReached",
}

export enum Title55 {
  InviteExpired = "InviteExpired",
  InviteInvalid = "InviteInvalid",
  InviteAlreadyAccepted = "InviteAlreadyAccepted",
}

export enum Title56 {
  MinimumThreeSociaalEmotioneelDoelenRequired = "MinimumThreeSociaalEmotioneelDoelenRequired",
  MaximumFiveSociaalEmotioneelDoelenAllowed = "MaximumFiveSociaalEmotioneelDoelenAllowed",
}

export enum Title57 {
  MinimumThreeSociaalEmotioneelDoelenRequired = "MinimumThreeSociaalEmotioneelDoelenRequired",
  UpdateNotAllowed = "UpdateNotAllowed",
  MaximumFiveSociaalEmotioneelDoelenAllowed = "MaximumFiveSociaalEmotioneelDoelenAllowed",
}

export enum Title58 {
  NotAllowedWhileImpersonating = "NotAllowedWhileImpersonating",
  TooManyAttachments = "TooManyAttachments",
}

export enum Title59 {
  NotAllowedWhileImpersonating = "NotAllowedWhileImpersonating",
  TooManyAttachments = "TooManyAttachments",
}

export enum Title60 {
  NotAllowedWhileImpersonating = "NotAllowedWhileImpersonating",
}

export enum Title61 {
  NotAllowedWhileImpersonating = "NotAllowedWhileImpersonating",
}

export enum Title62 {
  FileTooLarge = "FileTooLarge",
  FileCannotBeEmpty = "FileCannotBeEmpty",
  InvalidFileType = "InvalidFileType",
  UploadFailed = "UploadFailed",
}

export enum Title63 {
  UserIsBlocked = "UserIsBlocked",
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}
